var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _g4, _path11, _path12, _g5, _path13, _path14, _g6, _path15, _path16, _g7, _path17, _path18, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFramesGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 173,
    viewBox: "0 0 288 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282 0H6a6 6 0 0 0-6 6v160.25a6 6 0 0 0 6 6h276a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6",
    fill: "#eff3f9",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282 .31H6A5.69 5.69 0 0 0 .31 6v160.25A5.69 5.69 0 0 0 6 171.94h276a5.69 5.69 0 0 0 5.69-5.69V6A5.69 5.69 0 0 0 282 .31Z",
    stroke: "url(#paint0_linear_214_6090)",
    strokeWidth: 0.62
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 12H18.188A6.187 6.187 0 0 0 12 18.188v57.75a6.187 6.187 0 0 0 6.188 6.187h47.437a6.187 6.187 0 0 0 6.188-6.187v-57.75A6.187 6.187 0 0 0 65.625 12",
    fill: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 17,
    width: 48,
    height: 60
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.654 17.965H18.16V76.16h47.495z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.245 18.435H19.569a.94.94 0 0 0-.94.94V64.05c0 .519.42.94.94.94h44.676a.94.94 0 0 0 .94-.94V19.375a.94.94 0 0 0-.94-.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.305 19.375H20.508a.94.94 0 0 0-.94.94V63.11c0 .52.421.94.94.94h42.797a.94.94 0 0 0 .94-.94V20.315a.94.94 0 0 0-.94-.94",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.245 64.905H19.569a.94.94 0 0 0-.94.94v7.431c0 .52.42.94.94.94h44.676a.94.94 0 0 0 .94-.94v-7.432a.94.94 0 0 0-.94-.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.569 63.965h-.94v1.88h.94zm45.614 0h-.94v1.88h.94z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.815 67.723a.46.46 0 0 0-.21-.35.8.8 0 0 0-.463-.125.9.9 0 0 0-.346.064.53.53 0 0 0-.227.171.4.4 0 0 0-.079.246q0 .116.054.2a.5.5 0 0 0 .144.141q.09.055.194.094.103.036.198.06l.318.082q.155.039.318.103.164.066.303.172.14.106.226.263.087.157.087.376a.86.86 0 0 1-.143.49.95.95 0 0 1-.41.338 1.5 1.5 0 0 1-.65.124q-.364 0-.631-.116a.97.97 0 0 1-.417-.328.95.95 0 0 1-.167-.508h.492q.014.176.114.294a.6.6 0 0 0 .259.173q.158.055.347.055a1 1 0 0 0 .37-.065.6.6 0 0 0 .257-.184.44.44 0 0 0 .093-.278.34.34 0 0 0-.082-.236.6.6 0 0 0-.22-.152 2 2 0 0 0-.313-.106l-.384-.105a1.5 1.5 0 0 1-.619-.313.7.7 0 0 1-.227-.546q0-.28.153-.49.152-.21.412-.325.261-.117.587-.117.33 0 .582.115.255.117.4.32a.8.8 0 0 1 .153.462zm3.801.203h-.495a.76.76 0 0 0-.296-.484.8.8 0 0 0-.253-.127 1 1 0 0 0-.293-.043.9.9 0 0 0-.503.141.96.96 0 0 0-.349.414 1.6 1.6 0 0 0-.127.667q0 .396.127.67.13.272.35.412a.9.9 0 0 0 .5.14q.154 0 .292-.042a.8.8 0 0 0 .252-.125.77.77 0 0 0 .3-.478l.495.002q-.039.24-.154.44a1.2 1.2 0 0 1-.29.347q-.176.144-.403.223t-.495.08q-.422 0-.752-.2a1.4 1.4 0 0 1-.52-.576 2 2 0 0 1-.189-.893q0-.52.19-.894t.52-.574.751-.201q.259 0 .483.074.225.073.404.216.18.141.297.346.117.203.158.465m.84 2.192h-.52l1.169-3.249h.566l1.17 3.25h-.521l-.919-2.66h-.025zm.087-1.272h1.688v.412h-1.688zm5.389-1.977v3.25h-.45l-1.652-2.384h-.03v2.383h-.49V66.87h.453l1.653 2.386h.03V66.87zm1.897 0h.595l1.035 2.526h.038l1.034-2.526h.595v3.25h-.466v-2.352h-.03l-.959 2.346h-.387l-.958-2.348h-.03v2.353h-.467zm4.01 3.25v-3.25h2.037v.422h-1.547v.99h1.44v.42h-1.44v.995h1.566v.422z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.918 26.209h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375 26.209h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 26.209h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 26.209h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.073 26.209h.94v.94h-.94zm1.88 0h.94v.94h-.94zm-13.154.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 27.148h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm4.698 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm-15.035.94h.94v.94h-.94zm2.82 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 28.088h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.953 28.088h.94v.94h-.94zm-10.337.94h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 29.028h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 29.028h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm-9.398.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 29.967h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm-10.337.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.82 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-10.336 1.88h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375 32.787h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 32.787h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 32.787h.94v.94h-.94zm3.759 0h.94v.94h-.94zm-12.215.939h.94v.94h-.94zm2.819 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm8.458 0h.94v.94h-.94zm1.877 0h.94v.94h-.94zm1.882 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-27.25.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm4.697 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm3.76 0h.94v.94h-.94zm1.878 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 34.666h.94v.94h-.94zm.942 0h.94v.94h-.94zm-27.251.939h.94v.94h-.94zm6.579 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 35.605h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 35.605h.94v.94h-.94zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 35.605h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm-25.371.94h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 36.545h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.698 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.953 36.545h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 36.545h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 36.545h.94v.94h-.94zm-29.129.939h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.699 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.918 37.484h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 37.484h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm4.698 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.953 37.484h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 37.484h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 37.484h.94v.94h-.94zm2.82 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm-28.189.94h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 38.424h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.918 38.424h.94v.94h-.94zm.94 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 38.424h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 38.424h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 38.424h.94v.94h-.94zm3.76 0h.94v.94h-.94zm-26.31.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 39.364h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.821 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.833 39.364h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 39.364h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 39.364h.94v.94h-.94zm.942 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-29.129.94h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 40.304h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 40.304h.94v.94h-.94zm7.518 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-26.31.939h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.557 41.243h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 41.243h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm3.758 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 41.243h.94v.94h-.94zm.942 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 41.243h.94v.94h-.94zm.94 0h.94v.94h-.94zm-30.069.94h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.281 42.183h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 42.183h.94v.94h-.94zm7.518 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 42.183h.94v.94h-.94zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.953 42.183h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 42.183h.94v.94h-.94zm4.698 0h.94v.94h-.94zm-30.069.94h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.818-.001h.94v.94h-.94zm3.758.001h.94v.94h-.94zm2.82-.001h.94v.94h-.94zm1.878 0h.94v.94h-.94zm2.82.001h.94v.94h-.94zm1.88-.001h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.88.001h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.833 43.122h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 43.122h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.878.001h.94v.94h-.94zm-30.069.939h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.616 44.062h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.953 44.062h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-30.069.94h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.281 45.002h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 45.002h.94v.94h-.94zm3.76 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375 45.002h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm.942 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-29.129.939h.94v.94h-.94zm1.88-.001h.94v.94h-.94zm4.699 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm2.817 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375 45.941h.94v.94h-.94zm1.88-.001h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 45.94h.94v.94h-.94zm4.7.001h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.833 45.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 45.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 45.94h.94v.94h-.94zm.942 0h.94v.94h-.94zm-27.251.94h.94v.94h-.94zm9.398 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 46.88h.94v.94h-.94zm1.878 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.818 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.073 46.88h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.953 46.88h.94v.94h-.94zm-22.552.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.699 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm8.458 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 47.82h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 47.82h.94v.94h-.94zm2.82 0h.94v.94h-.94zm5.638 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 47.82h.94v.94h-.94zm.94 0h.94v.94h-.94zm-30.069.94h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 48.76h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.918 48.76h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 48.76h.94v.94h-.94zm1.879 0h.94v.94h-.94zm9.396 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm-22.552.94h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 49.7h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 49.7h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm6.578 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 49.7h.94v.94h-.94zm.94 0h.94v.94h-.94zm-21.612.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 50.64h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375 50.64h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm8.458 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 50.64h.94v.94h-.94zm-21.612.94h.94v.939h-.94zm3.76 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm2.819 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 51.58h.94v.939h-.94zm2.82 0h.94v.939h-.94zm5.638 0h.94v.939h-.94zm.94 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 51.58h.94v.939h-.94zm-20.672.939h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.82 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm7.518 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm-17.854.94h.94v.94h-.94zm4.7 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.073 53.459h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.878 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 53.459h.94v.94h-.94zm.942 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 53.459h.94v.94h-.94zm-20.672.939h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.496 54.398h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 54.398h.94v.94h-.94zm1.879 0h.94v.94h-.94zm5.637 0h.94v.94h-.94zm1.882 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 54.398h.94v.94h-.94zm.94 0h.94v.94h-.94zm-21.612.94h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.817 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.255 55.338h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 55.338h.94v.94h-.94zm1.879 0h.94v.94h-.94zm7.519 0h.94v.94h-.94zm-19.734.939h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 56.277h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.616 56.277h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.953 56.277h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.833 56.277h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.53 56.277h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.873 29.498a2.819 2.819 0 1 1 5.637 0 2.819 2.819 0 0 1-5.637 0Zm24.427 0a2.819 2.819 0 1 1 5.639 0 2.819 2.819 0 0 1-5.638 0Zm-24.427 24.43a2.819 2.819 0 1 1 5.638 0 2.819 2.819 0 0 1-5.638 0Z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.281 29.497a1.41 1.41 0 1 1 2.819 0 1.41 1.41 0 0 1-2.819 0m24.429 0a1.41 1.41 0 1 1 2.82 0 1.41 1.41 0 0 1-2.82 0M28.281 53.929a1.41 1.41 0 1 1 2.818 0 1.41 1.41 0 0 1-2.818 0m5.637-22.082h.94v.94h-.94zm-1.878 1.879h.939v.94h-.94zm3.759-1.879h.94v.94h-.94zm-3.759 3.758h.939v.94h-.94zm5.638-3.758h.94v.94h-.94zm-5.638 5.637h.939v.94h-.94zm7.517-5.637h.94v.94h-.94zm-7.517 7.517h.939v.94h-.94zm9.396-7.517h.94v.94h-.94zm-9.396 9.396h.939v.94h-.94zm11.276-9.396h.94v.94h-.94zM32.04 43.122h.939v.94h-.94zm13.154-11.275h.94v.94h-.94zM32.04 45.002h.939v.94h-.94zm15.033-13.155h.94v.94h-.94zM32.04 46.88h.939v.94h-.94zm16.913-15.033h.94v.94h-.94zM32.04 48.76h.939v.94h-.94zm16.913 0h.94v.94h-.94zm0 .94h.94v.94h-.94zm0 .94h.94v.94h-.94zm0 .94h.94v.939h-.94zm3.757-1.88h.94v.94h-.94zm0 .94h.94v.94h-.94zm0 .94h.94v.939h-.94zm0 .939h.94v.94h-.94zm-2.816-3.759h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.833 48.76h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 48.76h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.71 48.76h.94v.94h-.94zm-3.757 3.759h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.833 52.519h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.772 52.519h.94v.94h-.94zm-.939-1.879h.94v.94h-.94z",
    fill: "#9CA3AF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.688 12H86.25a6.187 6.187 0 0 0-6.187 6.188v57.75a6.187 6.187 0 0 0 6.187 6.187h47.438a6.187 6.187 0 0 0 6.187-6.187v-57.75A6.187 6.187 0 0 0 133.688 12",
    fill: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 17,
    width: 48,
    height: 60
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.717 17.965H86.222V76.16h47.495z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.303 27.66H87.627a.94.94 0 0 0-.94.94v44.676c0 .52.421.94.94.94h44.676a.94.94 0 0 0 .94-.94V28.6a.94.94 0 0 0-.94-.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.364 28.6H88.568a.94.94 0 0 0-.94.94v42.797c0 .519.42.94.94.94h42.796a.94.94 0 0 0 .94-.94V29.54a.94.94 0 0 0-.94-.94",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.303 18.435H87.627a.94.94 0 0 0-.94.94v7.432c0 .518.421.94.94.94h44.676a.94.94 0 0 0 .94-.94v-7.432a.94.94 0 0 0-.94-.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.627 26.807h-.94v1.879h.94zm45.616 0h-.939v1.879h.939z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.874 21.637a.46.46 0 0 0-.209-.35.8.8 0 0 0-.463-.125.9.9 0 0 0-.346.064.53.53 0 0 0-.227.171.4.4 0 0 0-.079.246.37.37 0 0 0 .053.2.5.5 0 0 0 .145.141q.09.055.193.094.103.036.199.06l.317.082q.156.039.319.104t.303.17a.77.77 0 0 1 .312.64.86.86 0 0 1-.142.49.95.95 0 0 1-.411.338 1.5 1.5 0 0 1-.649.124q-.365 0-.632-.116a1 1 0 0 1-.417-.328.95.95 0 0 1-.166-.508h.491q.015.176.115.294a.6.6 0 0 0 .258.173q.159.055.348.055a1 1 0 0 0 .369-.065.6.6 0 0 0 .257-.184.43.43 0 0 0 .094-.277.34.34 0 0 0-.082-.237.6.6 0 0 0-.221-.152 2 2 0 0 0-.313-.107l-.383-.104a1.5 1.5 0 0 1-.619-.313.7.7 0 0 1-.227-.545q0-.282.152-.49.153-.21.413-.326t.587-.117q.33 0 .582.116a1 1 0 0 1 .4.318.8.8 0 0 1 .152.464zm3.802.203h-.495a.8.8 0 0 0-.106-.28.8.8 0 0 0-.443-.331 1 1 0 0 0-.293-.043.9.9 0 0 0-.503.141.96.96 0 0 0-.349.414 1.6 1.6 0 0 0-.127.667q0 .396.127.67.128.272.35.412a.9.9 0 0 0 .5.14q.154 0 .292-.042a.8.8 0 0 0 .252-.125.76.76 0 0 0 .3-.478l.495.002a1.3 1.3 0 0 1-.154.44 1.2 1.2 0 0 1-.29.347q-.177.144-.403.223t-.495.08a1.4 1.4 0 0 1-.752-.2 1.4 1.4 0 0 1-.521-.576 2 2 0 0 1-.188-.893q0-.52.19-.894t.52-.574.751-.201q.258 0 .482.074.225.073.405.216.179.142.296.346.118.203.159.465m.839 2.192h-.52l1.169-3.249h.566l1.17 3.25h-.521l-.918-2.66h-.026zm.087-1.272h1.689v.412h-1.689zm5.389-1.977v3.25h-.45l-1.652-2.384h-.03v2.383h-.49v-3.249h.454l1.653 2.386h.03v-2.386zm1.898 0h.595l1.034 2.526h.038l1.035-2.526h.595v3.25h-.467V21.68h-.03l-.958 2.346h-.387l-.959-2.348h-.03v2.353h-.466zm4.009 3.25v-3.25h2.037v.422h-1.546v.99h1.44v.42h-1.44v.995h1.565v.422z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.978 35.434h.939v.94h-.939zm.94 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.942 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.375 35.434h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 35.434h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.881 0h.939v.94h-.939zm-13.158.94h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm4.698 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.881 0h.939v.94h-.939zm-15.037.94h.939v.94h-.939zm2.82 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 37.314h.939v.94h-.939zm1.881 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.375 37.314h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.943 0h.939v.94h-.939zm-10.339.939h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 38.253h.939v.94h-.939zm.939 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-9.396.94h.94v.94h-.94zm5.639 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.821 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676 40.132h.94v.94h-.94zm1.88 0h.939v.94h-.939zm2.819 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-10.335 1.88h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm.942 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.375 42.012h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 42.012h.94v.94h-.94zm3.762 0h.939v.94h-.939zm-12.217.94h.94v.94h-.94zm2.819 0h.94v.94h-.94zm2.82 0h.939v.94h-.939zm8.457 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-27.248.939h.94v.94h-.94zm1.878 0h.94v.94h-.94zm2.819 0h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.857 43.891h.94v.94h-.94zm4.699 0h.939v.94h-.939zm1.881 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.375 43.891h.94v.94h-.94zm2.819 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.711 43.891h.94v.94h-.94zm-27.249.94h.94v.94h-.94zm6.577 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.857 44.831h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 44.831h.939v.94h-.939zm2.819 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.881 0h.939v.94h-.939zm2.817 0h.94v.94h-.94zm-25.37.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 45.77h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.22 45.77h.939v.94h-.939zm.939 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.699 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.943 0h.939v.94h-.939zm1.879 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 45.77h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm-29.13.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.697 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.978 46.71h.939v.94h-.939zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.818 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm4.699 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.943 0h.939v.94h-.939zm1.879 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 46.71h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.529 46.71h.94v.94h-.94zm-28.187.94h.94v.94h-.94zm1.878 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.978 47.65h.939v.94h-.939zm.94 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm2.822 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 47.65h.94v.94h-.94zm.94 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm-26.309.94h.939v.94h-.939zm.939 0h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.857 48.59h.94v.94h-.94zm1.881 0h.94v.94h-.94zm2.818 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 48.59h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.711 48.59h.94v.94h-.94zm1.881 0h.94v.94h-.94zm-29.13.94h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 49.53h.94v.939h-.94zm1.881 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.22 49.53h.939v.939h-.939zm.939 0h.94v.939h-.94zm2.819 0h.939v.939h-.939zm.94 0h.94v.939h-.94zm1.88 0h.94v.939h-.94zm.94 0h.94v.939h-.94zm1.879 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 49.53h.939v.939h-.939zm7.516 0h.94v.939h-.94zm1.881 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm.94 0h.94v.939h-.94zm1.878 0h.94v.939h-.94zm-26.309.938h.939v.94h-.939zm3.758 0h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.617 50.468h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 50.468h.939v.94h-.939zm1.881 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm3.76 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.711 50.468h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.529 50.468h.94v.94h-.94zm-30.067.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 51.408h.94v.94h-.94zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.281 51.408h.94v.94h-.94zm7.517 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.818 0h.939v.94h-.939zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 51.408h.94v.94h-.94zm2.819 0h.94v.94h-.94zm.943 0h.939v.94h-.939zm1.879 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 51.408h.94v.94h-.94zm4.697 0h.94v.94h-.94zm-30.067.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 52.348h.94v.94h-.94zm2.82 0h.939v.94h-.939zm3.758 0h.939v.94h-.939zm2.82 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 52.348h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-30.067.94h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676 53.288h.94v.94h-.94zm1.88 0h.939v.94h-.939zm1.881 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.288h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.072 53.288h.94v.94h-.94zm.943 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.953 53.288h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm-30.067.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 54.228h.94v.94h-.94zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.281 54.228h.94v.94h-.94zm3.758 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm.942 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.881 0h.939v.94h-.939zm3.757 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.711 54.228h.94v.94h-.94zm1.881 0h.94v.94h-.94zm-29.13.939h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.697 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm3.761 0h.939v.94h-.939zm1.878 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 55.167h.94v.94h-.94zm4.7 0h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 55.167h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.711 55.167h.94v.94h-.94zm-27.249.939h.94v.94h-.94zm9.395 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm3.761 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.375 56.106h.94v.94h-.94zm2.819 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.072 56.106h.94v.94h-.94zm.943 0h.939v.94h-.939zm-22.553.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.697 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm8.457 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 57.046h.94v.94h-.94zm2.819 0h.94v.94h-.94zm5.639 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.529 57.046h.94v.94h-.94zm-30.067.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 57.985h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.22 57.985h.939v.94h-.939zm.939 0h.94v.94h-.94zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.978 57.985h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.857 57.985h.94v.94h-.94zm1.881 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm9.398 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.529 57.985h.94v.94h-.94zm-22.551.94h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.857 58.925h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 58.925h.939v.94h-.939zm1.881 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.375 58.925h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.072 58.925h.94v.94h-.94zm6.579 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.529 58.925h.94v.94h-.94zm-21.611.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 59.865h.939v.94h-.939zm.939 0h.94v.94h-.94zm.942 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm8.457 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm-21.614.94h.939v.94h-.939zm3.76 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 60.805h.94v.94h-.94zm2.819 0h.94v.94h-.94zm5.639 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm-20.674.94h.94v.94h-.94zm3.758 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm2.819 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm7.517 0h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.529 61.745h.94v.94h-.94zm-17.853.939h.94v.94h-.94zm4.699 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.072 62.684h.94v.94h-.94zm1.881 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.711 62.684h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm-20.674.94h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.556 63.624h.939v.94h-.939zm1.881 0h.939v.94h-.939zm1.878 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 63.624h.94v.94h-.94zm1.881 0h.94v.94h-.94zm5.638 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.529 63.624h.94v.94h-.94zm-21.611.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.857 64.564h.94v.94h-.94zm2.819 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.253 64.564h.94v.94h-.94zm1.881 0h.94v.94h-.94zm7.517 0h.94v.94h-.94zm-19.733.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.857 65.503h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.676 65.503h.94v.94h-.94zm.941 0h.94v.94h-.94zm3.758 0h.94v.94h-.94zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.072 65.503h.94v.94h-.94zm.943 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.953 65.503h.94v.94h-.94zm.941 0h.939v.94h-.939zm3.757 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.93 35.904h5.639v5.638h-5.638zm24.433 0h5.638v5.638h-5.638zM94.93 60.335h5.639v5.638h-5.638z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.342 37.314h2.819v2.818h-2.819zm24.43 0h2.819v2.818h-2.819zm-24.43 24.431h2.819v2.819h-2.819zm5.636-20.673h.939v.94h-.939zm-1.877 1.88h.939v.94h-.939zm3.756-1.88h.94v.94h-.94zm-3.756 3.759h.939v.94h-.939zm5.637-3.759h.94v.94h-.94zm-5.637 5.638h.939v.94h-.939zm7.516-5.638h.94v.94h-.94zm-7.516 7.518h.939v.94h-.939zm9.394-7.518h.94v.94h-.94zm-9.394 9.396h.939v.94h-.939zm11.274-9.396h.94v.94h-.94zm-11.274 11.276h.939v.94h-.939zm13.152-11.276h.94v.94h-.94zm-13.152 13.156h.939v.94h-.939zm15.033-13.156h.94v.94h-.94zm-15.033 15.034h.939v.94h-.939zm16.914-15.034h.939v.94h-.939zm-16.914 16.913h.939v.94h-.939zm16.914 0h.939v.94h-.939zm0 .94h.939v.94h-.939zm0 .94h.939v.94h-.939zm0 .94h.939v.94h-.939zm3.757-1.88h.94v.94h-.94zm0 .94h.94v.94h-.94zm0 .94h.94v.94h-.94zm0 .94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.953 57.985h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 57.985h.94v.94h-.94zm.94 0h.94v.94h-.94zm-3.757 3.76h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.953 61.745h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.832 61.745h.94v.94h-.94zm-.938-1.88h.939v.94h-.939z",
    fill: "#9CA3AF"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.75 12h-47.438a6.187 6.187 0 0 0-6.187 6.188v57.75a6.187 6.187 0 0 0 6.187 6.187h47.438a6.19 6.19 0 0 0 6.188-6.187v-57.75A6.19 6.19 0 0 0 201.75 12",
    fill: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 17,
    width: 48,
    height: 60
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.779 17.965h-47.495V76.16h47.495z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.562 26.668h1.94l-1.94 3.818-1.94-3.818z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37 18.428h-44.676a.933.933 0 0 0-.94.925v7.314c0 .511.421.925.94.925h44.676a.93.93 0 0 0 .939-.925v-7.314a.93.93 0 0 0-.939-.925",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.941 21.604a.46.46 0 0 0-.21-.349.8.8 0 0 0-.463-.125.9.9 0 0 0-.346.064.53.53 0 0 0-.227.17.4.4 0 0 0-.079.247q0 .116.054.2a.5.5 0 0 0 .144.14q.091.057.194.094t.198.06l.317.083q.156.039.319.103.164.065.303.172.14.105.226.263.087.157.087.376a.87.87 0 0 1-.143.49.95.95 0 0 1-.411.338 1.5 1.5 0 0 1-.649.124q-.364 0-.631-.116a.97.97 0 0 1-.417-.328.95.95 0 0 1-.167-.508h.492a.5.5 0 0 0 .114.293.6.6 0 0 0 .259.174q.158.055.347.055a1 1 0 0 0 .37-.065.6.6 0 0 0 .257-.184.44.44 0 0 0 .093-.278.34.34 0 0 0-.082-.236.6.6 0 0 0-.221-.152 2 2 0 0 0-.312-.107l-.384-.104a1.5 1.5 0 0 1-.619-.313.7.7 0 0 1-.227-.546q0-.28.153-.49a1 1 0 0 1 .412-.325q.26-.117.587-.118.33 0 .582.116.255.116.4.32a.8.8 0 0 1 .152.462zm3.801.204h-.495a.75.75 0 0 0-.296-.484.8.8 0 0 0-.253-.127 1 1 0 0 0-.293-.043.9.9 0 0 0-.503.141.97.97 0 0 0-.349.414 1.6 1.6 0 0 0-.127.666q0 .397.127.67.129.273.351.412.222.14.499.14.154 0 .292-.041a.9.9 0 0 0 .253-.126.77.77 0 0 0 .299-.477l.495.002q-.039.24-.154.44a1.2 1.2 0 0 1-.29.346q-.176.145-.403.224-.226.08-.495.08-.422 0-.752-.2a1.4 1.4 0 0 1-.52-.576 1.96 1.96 0 0 1-.189-.894q0-.52.19-.893a1.4 1.4 0 0 1 .521-.574q.33-.201.75-.202.259 0 .482.075.226.073.405.216.18.142.297.346t.158.465m.84 2.192h-.521l1.169-3.25h.567l1.169 3.25h-.52l-.919-2.659h-.025zm.087-1.272h1.688v.412h-1.688zm5.389-1.977V24h-.451l-1.651-2.383h-.03V24h-.491v-3.25h.454l1.653 2.387h.03V20.75zm1.897 0h.595l1.035 2.526h.038l1.034-2.526h.595V24h-.466v-2.351h-.031l-.958 2.346h-.387l-.958-2.348h-.03V24h-.467zm4.01 3.249v-3.25h2.037v.423h-1.547v.99h1.441v.42h-1.441v.995h1.566V24z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.043 37.093h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm1.879 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44 37.093h.94v.925h-.94zm.942 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 37.093h.94v.925h-.94zm.942 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm-13.155.925h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.862 38.018h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm4.699 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm-15.037.925h.94v.925h-.94zm2.819 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.881 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44 38.943h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm-10.336.924h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 39.867h.939v.925h-.939zm.939 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm-9.396.926h.94v.924h-.94zm5.638 0h.939v.924h-.939zm1.879 0h.939v.924h-.939zm2.819 0h.94v.924h-.94zm-10.336.924h.94v.925h-.94zm1.878 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm-10.335 1.85h.94v.925h-.94zm3.76 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44 43.567h.94v.925h-.94zm.942 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 43.567h.94v.925h-.94zm3.761 0h.94v.925h-.94zm-12.218.925h.94v.925h-.94zm2.821 0h.939v.925h-.939zm2.82 0h.94v.925h-.94zm8.457 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm1.879 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm-27.249.925h.939v.924h-.939zm1.88 0h.939v.924h-.939zm2.817 0h.94v.924h-.94zm.941 0h.94v.924h-.94zm.941 0h.939v.924h-.939zm4.697 0h.94v.924h-.94zm1.881 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44 45.417h.94v.924h-.94zm2.821 0h.939v.924h-.939zm3.758 0h.939v.924h-.939zm1.879 0h.94v.924h-.94zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.777 45.417h.94v.924h-.94zm-27.251.924h.94v.925h-.94zm6.581 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.862 46.341h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm-25.372.926h.94v.924h-.94zm.942 0h.939v.924h-.939zm1.878 0h.939v.924h-.939zm.941 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.226 47.267h.939v.924h-.939zm1.881 0h.94v.924h-.94zm4.698 0h.939v.924h-.939zm3.757 0h.94v.924h-.94zm1.878 0h.94v.924h-.94zm2.821 0h.939v.924h-.939zm1.879 0h.939v.924h-.939zm.94 0h.94v.924h-.94zm1.88 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 47.267h.94v.924h-.94zm1.879 0h.94v.924h-.94zm.94 0h.939v.924h-.939zm.94 0h.94v.924h-.94zm-29.131.924h.94v.925h-.94zm1.881 0h.94v.925h-.94zm4.7 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.043 48.191h.94v.925h-.94zm1.882 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.862 48.191h.94v.925h-.94zm.943 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm4.699 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 48.191h.94v.925h-.94zm.94 0h.94v.925h-.94zm2.819 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.595 48.191h.939v.925h-.939zm-28.188.925h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.226 49.116h.939v.925h-.939zm1.881 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.043 49.116h.94v.925h-.94zm.941 0h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 49.116h.939v.925h-.939zm3.757 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm2.82 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 49.116h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.757 0h.939v.925h-.939zm-26.308.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.226 50.041h.939v.925h-.939zm3.758 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm1.882 0h.94v.925h-.94zm2.818 0h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 50.041h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.777 50.041h.94v.925h-.94zm1.88 0h.94v.925h-.94zm-29.131.925h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.226 50.966h.939v.925h-.939zm2.817 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm7.518 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm1.879 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm1.878 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.287 51.89h.94v.925h-.94zm3.756 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm4.699 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm1.879 0h.939v.925h-.939zm3.758 0h.939v.925h-.939zm3.758 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.777 51.89h.94v.925h-.94zm.94 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.595 51.89h.939v.925h-.939zm-30.069.925h.94v.925h-.94zm.942 0h.939v.925h-.939zm.939 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.346 52.815h.939v.925h-.939zm7.516 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm3.76 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 52.815h.94v.925h-.94zm2.821 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 52.815h.94v.925h-.94zm4.697 0h.939v.925h-.939zm-30.069.925h.94v.925h-.94zm.942 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm3.756 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm1.882 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 53.74h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm-30.069.925h.94v.925h-.94zm2.82 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm1.881 0h.94v.925h-.94zm3.755 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm1.881 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44 54.665h.94v.925h-.94zm3.761 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14 54.665h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.019 54.665h.939v.925h-.939zm3.758 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm-30.069.925h.94v.925h-.94zm.942 0h.939v.925h-.939zm.939 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.346 55.59h.939v.925h-.939zm3.761 0h.94v.925h-.94zm3.755 0h.94v.925h-.94zm1.882 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.879 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm3.758 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.777 55.59h.94v.925h-.94zm1.88 0h.94v.925h-.94zm-29.131.925h.94v.925h-.94zm1.881 0h.94v.925h-.94zm4.7 0h.94v.925h-.94zm2.818 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm1.879 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 56.515h.94v.925h-.94zm4.7 0h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 56.515h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.777 56.515h.94v.925h-.94zm-27.251.925h.94v.925h-.94zm9.399 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.862 57.44h.94v.925h-.94zm1.882 0h.94v.925h-.94zm3.759 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44 57.44h.94v.925h-.94zm2.821 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14 57.44h.939v.925h-.939zm.94 0h.94v.925h-.94zm-22.554.924h.94v.925h-.94zm1.881 0h.94v.925h-.94zm4.7 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm8.456 0h.94v.925h-.94zm.942 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 58.364h.94v.925h-.94zm2.821 0h.939v.925h-.939zm5.637 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.595 58.364h.939v.925h-.939zm-30.069.926h.94v.924h-.94zm.942 0h.939v.924h-.939zm1.878 0h.939v.924h-.939zm.941 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.226 59.29h.939v.924h-.939zm1.881 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.043 59.29h.94v.924h-.94zm.941 0h.94v.924h-.94zm.941 0h.939v.924h-.939zm1.88 0h.939v.924h-.939zm3.757 0h.94v.924h-.94zm1.878 0h.94v.924h-.94zm.942 0h.939v.924h-.939zm1.879 0h.939v.924h-.939zm9.396 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.595 59.29h.939v.924h-.939zm-22.552.924h.94v.925h-.94zm.941 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.862 60.214h.94v.925h-.94zm2.821 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.881 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44 60.214h.94v.925h-.94zm3.761 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14 60.214h.939v.925h-.939zm6.577 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.595 60.214h.939v.925h-.939zm-21.611.926h.94v.924h-.94zm1.878 0h.94v.924h-.94zm2.821 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm.941 0h.94v.924h-.94zm1.879 0h.939v.924h-.939zm1.879 0h.939v.924h-.939zm8.456 0h.939v.924h-.939zm.94 0h.94v.924h-.94zm-21.614.924h.94v.925h-.94zm3.762 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm1.879 0h.94v.925h-.94zm2.82 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 62.064h.94v.925h-.94zm2.821 0h.939v.925h-.939zm5.637 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm-20.673.925h.94v.925h-.94zm3.76 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm7.516 0h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.595 62.989h.939v.925h-.939zm-17.851.925h.94v.924h-.94zm4.696 0h.94v.924h-.94zm1.879 0h.94v.924h-.94zm.942 0h.939v.924h-.939zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14 63.914h.939v.924h-.939zm1.879 0h.939v.924h-.939zm1.879 0h.94v.924h-.94zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.777 63.914h.94v.924h-.94zm.94 0h.939v.924h-.939zm.94 0h.94v.924h-.94zm-20.673.924h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 64.838h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm1.879 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 64.838h.94v.925h-.94zm1.882 0h.94v.925h-.94zm5.637 0h.94v.925h-.94zm1.879 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.595 64.838h.939v.925h-.939zm-21.611.925h.94v.925h-.94zm.941 0h.939v.925h-.939zm2.819 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 65.763h.939v.925h-.939zm3.757 0h.94v.925h-.94zm.942 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.319 65.763h.94v.925h-.94zm1.882 0h.94v.925h-.94zm7.516 0h.939v.925h-.939zm-19.733.925h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.862 66.688h.94v.925h-.94zm.943 0h.939v.925h-.939zm.939 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 66.688h.939v.925h-.939zm3.757 0h.94v.925h-.94zm3.761 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14 66.688h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.019 66.688h.939v.925h-.939zm.941 0h.94v.925h-.94zm3.757 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.998 37.555h5.638v5.55h-5.638zm24.432 0h5.638v5.55h-5.638zm-24.432 24.047h5.638v5.549h-5.638z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.407 38.943h2.819v2.774h-2.819zm24.431 0h2.819v2.774h-2.819zm-24.431 24.046h2.819v2.774h-2.819zm5.636-20.347h.94v.925h-.94zm-1.878 1.85h.94v.925h-.94zm3.76-1.85h.939v.925h-.939zm-3.76 3.699h.94v.925h-.94zm5.64-3.699h.939v.925h-.939zm-5.64 5.549h.94v.925h-.94zm7.518-5.549h.939v.925h-.939zm-7.518 7.399h.94v.925h-.94zm9.397-7.399h.94v.925h-.94zm-9.397 9.248h.94v.925h-.94zm11.275-9.248h.94v.925h-.94zM168.165 53.74h.94v.925h-.94zm13.154-11.098h.94v.925h-.94zM168.165 55.59h.94v.925h-.94zm15.036-12.948h.94v.925h-.94zM168.165 57.44h.94v.925h-.94zm16.915-14.798h.94v.925h-.94zM168.165 59.29h.94v.924h-.94zm16.915 0h.94v.924h-.94zm0 .924h.94v.925h-.94zm0 .926h.94v.924h-.94zm0 .924h.94v.925h-.94zm3.758-1.85h.94v.925h-.94zm0 .926h.94v.924h-.94zm0 .924h.94v.925h-.94zm0 .925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.019 59.29h.939v.924h-.939zm.941 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 59.29h.94v.924h-.94zm.94 0h.94v.924h-.94zm-3.758 3.699h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.019 62.989h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.898 62.989h.94v.925h-.94zm-.938-1.849h.94v.924h-.94z",
    fill: "#9CA3AF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M269.813 12h-47.438a6.187 6.187 0 0 0-6.187 6.188v57.75a6.187 6.187 0 0 0 6.187 6.187h47.438A6.187 6.187 0 0 0 276 75.938v-57.75A6.187 6.187 0 0 0 269.813 12",
    fill: "#F3F4F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 17,
    width: 48,
    height: 60
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M269.842 17.965h-47.495V76.16h47.495z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.624 63.325 1.94 3.819h-3.879z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.432 66.1h-44.676a.933.933 0 0 0-.94.925v7.314c0 .511.421.925.94.925h44.676c.519 0 .94-.414.94-.925v-7.314a.933.933 0 0 0-.94-.925",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.001 69.276a.46.46 0 0 0-.209-.349.8.8 0 0 0-.463-.125.9.9 0 0 0-.346.063.53.53 0 0 0-.227.172.4.4 0 0 0-.079.246q0 .115.053.2a.5.5 0 0 0 .145.14q.09.057.193.094.103.038.199.06l.317.083q.156.038.319.103t.303.172q.14.105.225.263.087.157.087.376a.86.86 0 0 1-.142.49.95.95 0 0 1-.411.338 1.5 1.5 0 0 1-.649.124q-.365 0-.632-.116a1 1 0 0 1-.417-.328.95.95 0 0 1-.166-.508h.491q.015.176.115.293a.6.6 0 0 0 .258.173q.159.056.348.056a1 1 0 0 0 .369-.065.6.6 0 0 0 .257-.184.43.43 0 0 0 .094-.278.34.34 0 0 0-.083-.236.6.6 0 0 0-.22-.153 2 2 0 0 0-.313-.106l-.384-.105a1.5 1.5 0 0 1-.618-.312.7.7 0 0 1-.227-.546q0-.28.152-.49.153-.21.413-.325a1.4 1.4 0 0 1 .587-.118q.33 0 .582.116a1 1 0 0 1 .4.319.8.8 0 0 1 .152.463zm3.802.203h-.495a.8.8 0 0 0-.106-.279.8.8 0 0 0-.443-.332 1 1 0 0 0-.294-.042.9.9 0 0 0-.502.14.96.96 0 0 0-.349.415 1.6 1.6 0 0 0-.127.666q0 .397.127.67.128.273.35.412a.9.9 0 0 0 .5.14q.154 0 .292-.041a.8.8 0 0 0 .252-.126.75.75 0 0 0 .3-.477l.495.001q-.04.24-.154.441a1.2 1.2 0 0 1-.29.346q-.177.145-.403.224-.228.08-.495.08a1.4 1.4 0 0 1-.752-.2 1.4 1.4 0 0 1-.521-.576 1.96 1.96 0 0 1-.188-.894q0-.52.19-.893.19-.375.52-.574.33-.202.751-.202.258 0 .482.075.225.072.405.216.179.14.296.346.118.203.159.464m.839 2.193h-.52l1.169-3.25h.566l1.17 3.25h-.521l-.918-2.66h-.026zm.087-1.272h1.688v.412h-1.688zm5.389-1.977v3.249h-.45l-1.652-2.383h-.03v2.383h-.49v-3.25h.454l1.653 2.387h.03v-2.386zm1.898 0h.595l1.034 2.525h.038l1.035-2.525h.595v3.249h-.467V69.32h-.03l-.958 2.346h-.387l-.959-2.348h-.03v2.353h-.466zm4.009 3.249v-3.25h2.037v.423h-1.546v.99h1.44v.42h-1.44v.995h1.565v.422z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.106 26.079h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 26.079h.94v.924h-.94zm1.88 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm1.879 0h.94v.924h-.94zm1.879 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm.941 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 26.079h.94v.924h-.94zm.94 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm.941 0h.939v.924h-.939zm1.88 0h.939v.924h-.939zm-13.156.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.925 27.004h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm4.699 0h.94v.925h-.94zm2.82 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm-15.036.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.925 27.929h.939v.925h-.939zm2.818 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.877 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.879 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm-10.336.925h.939v.924h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.743 28.854h.94v.924h-.94zm.942 0h.939v.924h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.622 28.854h.94v.924h-.94zm1.881 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 28.854h.94v.924h-.94zm1.879 0h.94v.924h-.94zm1.878 0h.94v.924h-.94zm-9.393.924h.939v.925h-.939zm5.636 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm-10.336.925h.939v.925h-.939zm1.879 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm1.879 0h.939v.925h-.939zm-10.337 1.85h.94v.925h-.94zm3.761 0h.939v.925h-.939zm1.879 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.622 32.553h.94v.925h-.94zm.94 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 32.553h.94v.925h-.94zm.94 0h.939v.925h-.939zm3.76 0h.939v.925h-.939zm-12.217.925h.939v.924h-.939zm2.818 0h.94v.924h-.94zm2.819 0h.94v.924h-.94zm8.457 0h.939v.924h-.939zm1.879 0h.94v.924h-.94zm1.881 0h.94v.924h-.94zm1.879 0h.94v.924h-.94zm-27.25.924h.94v.925h-.94zm1.88 0h.94v.925h-.94zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 34.402h.94v.925h-.94zm.941 0h.94v.925h-.94zm4.699 0h.939v.925h-.939zm1.877 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm3.761 0h.94v.925h-.94zm1.878 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 34.402h.94v.925h-.94zm.94 0h.94v.925h-.94zm-27.249.925h.94v.925h-.94zm6.577 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.925 35.327h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 35.327h.94v.925h-.94zm2.82 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm-25.371.925h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm4.698 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.877 0h.939v.925h-.939zm.941 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm-29.13.925h.94v.925h-.94zm1.879 0h.939v.925h-.939zm4.698 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.925 37.177h.939v.925h-.939zm.939 0h.94v.925h-.94zm2.821 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.622 37.177h.94v.925h-.94zm4.699 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.877 0h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 37.177h.94v.925h-.94zm2.821 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-28.19.925h.939v.925h-.939zm1.881 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 38.102h.94v.925h-.94zm3.761 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.743 38.102h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 38.102h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm2.82 0h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 38.102h.94v.925h-.94zm3.76 0h.94v.925h-.94zm-26.309.925h.939v.925h-.939zm.939 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm2.821 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.622 39.027h.94v.925h-.94zm3.76 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm2.82 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.019 39.027h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 39.027h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.881 0h.939v.925h-.939zm-29.13.925h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 39.952h.94v.925h-.94zm1.88 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm7.514 0h.94v.925h-.94zm1.883 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm-26.309.925h.939v.924h-.939zm3.757 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 40.877h.94v.924h-.94zm4.698 0h.94v.924h-.94zm.942 0h.939v.924h-.939zm1.877 0h.94v.924h-.94zm1.88 0h.94v.924h-.94zm3.757 0h.94v.924h-.94zm3.761 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 40.877h.94v.924h-.94zm.94 0h.94v.924h-.94zm.941 0h.94v.924h-.94zm.94 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm-30.069.924h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.468 41.801h.939v.925h-.939zm.94 0h.94v.925h-.94zm7.517 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm3.757 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.877 0h.939v.925h-.939zm.941 0h.94v.925h-.94zm4.698 0h.94v.925h-.94zm-30.069.925h.94v.925h-.94zm.94 0h.94v.925h-.94zm2.82 0h.939v.925h-.939zm3.757 0h.94v.925h-.94zm2.819 0h.939v.925h-.939zm1.881 0h.939v.925h-.939zm2.816 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm1.883 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.019 42.726h.939v.925h-.939zm.941 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm-30.069.924h.94v.926h-.94zm2.819 0h.94v.926h-.94zm1.88 0h.94v.926h-.94zm1.878 0h.94v.926h-.94zm3.759 0h.939v.926h-.939zm.939 0h.94v.926h-.94zm.942 0h.939v.926h-.939zm1.879 0h.939v.926h-.939zm1.877 0h.94v.926h-.94zm.941 0h.94v.926h-.94zm3.759 0h.939v.926h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.199 43.65h.94v.926h-.94zm.943 0h.939v.926h-.939zm.94 0h.94v.926h-.94zm3.756 0h.94v.926h-.94zm.941 0h.94v.926h-.94zm1.879 0h.94v.926h-.94zm-30.069.926h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.468 44.576h.939v.925h-.939zm.94 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm3.759 0h.939v.925h-.939zm1.881 0h.939v.925h-.939zm2.816 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm2.82 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm3.756 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.881 0h.939v.925h-.939zm-29.13.925h.94v.925h-.94zm1.879 0h.939v.925h-.939zm4.698 0h.94v.925h-.94zm2.82 0h.94v.925h-.94zm2.82 0h.939v.925h-.939zm3.756 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm4.7 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.019 45.501h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 45.501h.94v.925h-.94zm.94 0h.94v.925h-.94zm-27.249.924h.94v.925h-.94zm9.397 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.925 46.425h.939v.925h-.939zm1.881 0h.939v.925h-.939zm3.756 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.199 46.425h.94v.925h-.94zm.943 0h.939v.925h-.939zm-22.553.925h.94v.925h-.94zm1.879 0h.939v.925h-.939zm4.698 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm8.458 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 47.35h.94v.925h-.94zm.94 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm5.639 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-30.069.925h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 48.275h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm1.881 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 48.275h.94v.925h-.94zm1.879 0h.94v.925h-.94zm9.398 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-22.552.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 49.2h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.925 49.2h.939v.925h-.939zm2.818 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.877 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm3.759 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.199 49.2h.94v.925h-.94zm6.58 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-21.613.925h.94v.925h-.94zm1.88 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm.942 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.622 50.125h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm8.458 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm-21.613.925h.94v.925h-.94zm3.758 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm2.82 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm5.639 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm-20.674.925h.94v.925h-.94zm3.761 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm7.517 0h.94v.925h-.94zm1.881 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-17.852.925h.939v.924h-.939zm4.697 0h.94v.924h-.94zm1.879 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm.941 0h.939v.924h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.199 52.9h.94v.924h-.94zm1.883 0h.94v.924h-.94zm1.878 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 52.9h.94v.924h-.94zm.94 0h.94v.924h-.94zm.941 0h.94v.924h-.94zm.94 0h.939v.924h-.939zm-20.674.924h.94v.925h-.94zm3.761 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.743 53.824h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.877 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm5.636 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-21.613.925h.94v.925h-.94zm.941 0h.94v.925h-.94zm2.82 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.743 54.749h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 54.749h.94v.925h-.94zm.94 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm7.517 0h.94v.925h-.94zm-19.734.925h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.925 55.674h.939v.925h-.939zm.939 0h.94v.925h-.94zm.942 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.743 55.674h.94v.925h-.94zm3.76 0h.94v.925h-.94zm3.759 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.199 55.674h.94v.925h-.94zm.943 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.019 55.674h.939v.925h-.939zm3.76 0h.94v.925h-.94zm.94 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.059 26.541h5.637v5.55h-5.637zm24.432 0h5.638v5.55h-5.638zm-24.432 24.046h5.637v5.55h-5.637z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.468 27.929h2.819v2.774h-2.819zm24.43 0h2.819v2.774h-2.819zm-24.43 24.046h2.819v2.774h-2.819zm5.638-20.347h.94v.925h-.94zm-1.878 1.85h.939v.924h-.939zm3.758-1.85h.94v.925h-.94zm-3.758 3.699h.939v.925h-.939zm5.636-3.699h.94v.925h-.94zm-5.636 5.549h.939v.925h-.939zm7.515-5.549h.94v.925h-.94zm-7.515 7.399h.939v.925h-.939zm9.394-7.399h.94v.925h-.94zm-9.394 9.249h.939v.924h-.939zm11.275-9.249h.94v.925h-.94zm-11.275 11.098h.939v.925h-.939zm13.154-11.098h.939v.925h-.939zm-13.154 12.948h.939v.925h-.939zm15.034-12.948h.939v.925h-.939zm-15.034 14.797h.939v.925h-.939zm16.914-14.797h.939v.925h-.939zm-16.914 16.647h.939v.925h-.939zm16.914 0h.939v.925h-.939zm0 .925h.939v.925h-.939zm0 .925h.939v.925h-.939zm0 .925h.939v.925h-.939zm3.756-1.85h.94v.925h-.94zm0 .925h.94v.925h-.94zm0 .925h.94v.925h-.94zm0 .925h.94v.925h-.94zm-2.816-3.7h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.019 48.275h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.898 48.275h.94v.925h-.94zm-3.756 3.7h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.019 51.975h.939v.925h-.939zm.941 0h.94v.925h-.94zm-.941-1.85h.939v.925h-.939z",
    fill: "#9CA3AF"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 90.125H18.188A6.187 6.187 0 0 0 12 96.313v57.749a6.187 6.187 0 0 0 6.188 6.188h47.437a6.187 6.187 0 0 0 6.188-6.188v-57.75a6.187 6.187 0 0 0-6.188-6.187",
    fill: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 96,
    width: 48,
    height: 59
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.654 96.09H18.16v58.194h47.495z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.244 96.553H19.567a.93.93 0 0 0-.94.925v43.972c0 .511.42.925.94.925h44.676c.519 0 .94-.414.94-.925V97.478a.93.93 0 0 0-.94-.925",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.307 97.478H20.51a.93.93 0 0 0-.94.924v42.123c0 .511.421.925.94.925h42.797c.519 0 .94-.414.94-.925V98.402a.93.93 0 0 0-.94-.924",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.148 97.015h15.518m15.05 14.812v15.274m-30.568 14.812h15.518m-30.567-30.086v15.274",
    stroke: "#F9FAFB",
    strokeWidth: 1.034
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.815 145.551a.47.47 0 0 0-.21-.349.8.8 0 0 0-.463-.125.9.9 0 0 0-.346.063.54.54 0 0 0-.227.172.4.4 0 0 0-.079.246q0 .116.054.2a.5.5 0 0 0 .144.141q.09.056.194.093.103.037.198.061l.318.082q.155.039.319.103.163.066.303.172a.76.76 0 0 1 .313.639.86.86 0 0 1-.144.49.95.95 0 0 1-.41.338 1.5 1.5 0 0 1-.65.124q-.364 0-.631-.116a.97.97 0 0 1-.417-.328.95.95 0 0 1-.167-.508h.492q.014.176.114.294a.6.6 0 0 0 .259.173q.158.055.347.055a1 1 0 0 0 .37-.065.6.6 0 0 0 .257-.184.44.44 0 0 0 .094-.278.34.34 0 0 0-.083-.236.6.6 0 0 0-.22-.152 2 2 0 0 0-.313-.107l-.384-.104a1.5 1.5 0 0 1-.619-.313.7.7 0 0 1-.227-.546q0-.28.153-.49a1 1 0 0 1 .412-.325 1.4 1.4 0 0 1 .587-.118q.33 0 .583.116t.4.319a.8.8 0 0 1 .152.463zm3.802.203h-.495a.77.77 0 0 0-.55-.61 1 1 0 0 0-.293-.043.9.9 0 0 0-.503.141.96.96 0 0 0-.349.414 1.6 1.6 0 0 0-.127.667q0 .396.127.669.129.273.351.413a.9.9 0 0 0 .5.139q.154 0 .292-.041a.78.78 0 0 0 .552-.603l.495.002a1.3 1.3 0 0 1-.154.441 1.2 1.2 0 0 1-.29.346q-.177.144-.403.223-.228.08-.495.08-.422 0-.752-.2a1.4 1.4 0 0 1-.52-.576 2 2 0 0 1-.19-.893q0-.52.19-.894.192-.374.521-.574.33-.202.75-.202.26 0 .483.075.225.073.404.216.18.14.297.346.117.203.159.464m.84 2.193h-.521l1.17-3.249h.566l1.169 3.249h-.52l-.92-2.659h-.025zm.087-1.272h1.688v.412h-1.688zm5.389-1.977v3.249h-.45l-1.652-2.383h-.03v2.383h-.49v-3.249h.453l1.653 2.386h.03v-2.386zm1.898 0h.595l1.034 2.526h.038l1.035-2.526h.595v3.249h-.467v-2.351h-.03l-.958 2.347h-.387l-.959-2.349h-.03v2.353h-.466zm4.01 3.249v-3.249h2.037v.422H50.33v.99h1.44v.42h-1.44v.995h1.566v.422z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.919 104.204h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.858 104.204h.94v.924h-.94zm.942 0h.94v.924h-.94zm1.878 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm4.698 0h.94v.924h-.94zm2.819 0h.94v.924h-.94zm1.88 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.954 104.204h.94v.924h-.94zm-15.035.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.858 105.129h.94v.925h-.94zm.942 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 105.129h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.881 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.497 105.129h.94v.925h-.94zm3.759 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm-15.035.925h.94v.925h-.94zm2.819 0h.94v.925h-.94zm2.821 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.497 106.054h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.316 106.054h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.954 106.054h.94v.925h-.94zm-14.096.925h.94v.924h-.94zm.942 0h.94v.924h-.94zm2.818 0h.94v.924h-.94zm2.82 0h.94v.924h-.94zm1.878 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm2.819 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm-10.337.924h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.377 107.903h.94v.925h-.94zm3.758 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm-14.096.925h.94v.925h-.94zm2.82 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm5.638 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 108.828h.94v.925h-.94zm.941 0h.94v.925h-.94zm-2.819 1.85h.94v.925h-.94zm2.819 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm-20.672.925h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 111.603h.94v.924h-.94zm5.638 0h.94v.924h-.94zm.942 0h.94v.924h-.94zm1.878 0h.94v.924h-.94zm2.819 0h.94v.924h-.94zm1.88 0h.94v.924h-.94zm2.817 0h.94v.924h-.94zm.941 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm2.819 0h.94v.924h-.94zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 111.603h.94v.924h-.94zm2.819 0h.94v.924h-.94zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.47 111.603h.94v.924h-.94zm-28.188.924h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 112.527h.94v.925h-.94zm3.758 0h.94v.925h-.94zm.942 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 112.527h.94v.925h-.94zm1.88 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm2.816 0h.94v.925h-.94zm2.82 0h.94v.925h-.94zm-30.07.925h.94v.925h-.94zm6.58 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.942 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 113.452h.94v.925h-.94zm2.821 0h.94v.925h-.94zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.316 113.452h.94v.925h-.94zm1.878 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm4.698 0h.94v.925h-.94zm-25.373.925h.94v.925h-.94zm.943 0h.94v.925h-.94zm2.819 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 114.377h.94v.925h-.94zm1.88 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm4.699 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm2.816 0h.94v.925h-.94zm.942 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm-29.132.925h.94v.925h-.94zm.943 0h.94v.925h-.94zm2.819 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 115.302h.94v.925h-.94zm2.819 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.858 115.302h.94v.925h-.94zm.942 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 115.302h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm2.817 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.954 115.302h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm-27.25.925h.94v.925h-.94zm4.7 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm4.699 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.497 116.227h.94v.925h-.94zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm1.879 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65 116.227h.94v.925h-.94zm2.82 0h.94v.925h-.94zm-30.07.925h.94v.925h-.94zm3.762 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.942 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm3.756 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 117.152h.94v.925h-.94zm.94 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm-27.25.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 118.077h.94v.925h-.94zm.942 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm1.881 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 118.077h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.76 0h.94v.925h-.94zm3.756 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm-28.192.924h.94v.925h-.94zm1.882 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm4.701 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.497 119.001h.94v.925h-.94zm1.88 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65 119.001h.94v.925h-.94zm1.882 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.47 119.001h.94v.925h-.94zm-26.308.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 119.926h.94v.925h-.94zm3.758 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm6.578 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 119.926h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.954 119.926h.94v.925h-.94zm1.88 0h.94v.925h-.94zm-24.434.925h.94v.925h-.94zm1.882 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 120.851h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.919 120.851h.94v.925h-.94zm1.881 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.316 120.851h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 120.851h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm4.698 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm-29.132.925h.94v.925h-.94zm.943 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.282 121.776h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 121.776h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.919 121.776h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.858 121.776h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.759 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.316 121.776h.94v.925h-.94zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.954 121.776h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm.942 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm-29.132.925h.94v.925h-.94zm2.82 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm3.759 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65 122.701h.94v.925h-.94zm1.882 0h.94v.925h-.94zm-29.132.925h.94v.925h-.94zm2.82 0h.94v.925h-.94zm.942 0h.94v.925h-.94zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.919 123.626h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.858 123.626h.94v.925h-.94zm2.82 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm1.879 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 123.626h.94v.925h-.94zm1.881 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm3.756 0h.94v.925h-.94zm2.82 0h.94v.925h-.94zm-30.07.924h.94v.925h-.94zm8.458 0h.94v.925h-.94zm.942 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.256 124.55h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.954 124.55h.94v.925h-.94zm-22.554.926h.94v.924h-.94zm1.882 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 125.476h.94v.924h-.94zm3.76 0h.94v.924h-.94zm6.579 0h.94v.924h-.94zm1.879 0h.94v.924h-.94zm3.756 0h.94v.924h-.94zm.941 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm3.758 0h.94v.924h-.94zm1.877 0h.94v.924h-.94zm.942 0h.94v.924h-.94zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.47 125.476h.94v.924h-.94zm-30.07.924h.94v.925h-.94zm1.882 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.22 126.4h.94v.925h-.94zm5.638 0h.94v.925h-.94zm4.701 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.497 126.4h.94v.925h-.94zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm5.635 0h.94v.925h-.94zm-19.731.925h.94v.925h-.94zm1.881 0h.94v.925h-.94zm4.697 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.377 127.325h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.316 127.325h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm8.457 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.47 127.325h.94v.925h-.94zm-21.612.925h.94v.925h-.94zm2.82 0h.94v.925h-.94zm5.638 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm6.577 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm-20.674.925h.94v.925h-.94zm.942 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm5.635 0h.94v.925h-.94zm.942 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.47 129.175h.94v.925h-.94zm-22.551.925h.94v.924h-.94zm8.458 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.316 130.1h.94v.924h-.94zm2.819 0h.94v.924h-.94zm7.515 0h.94v.924h-.94zm1.882 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.47 130.1h.94v.924h-.94zm-22.551.924h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.858 131.024h.94v.925h-.94zm3.76 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm4.697 0h.94v.925h-.94zm1.881 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm-21.613.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.858 131.949h.94v.925h-.94zm.942 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 131.949h.94v.925h-.94zm3.759 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm6.577 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.758 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8 132.874h.94v.925h-.94zm2.818 0h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.497 132.874h.94v.925h-.94zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.194 132.874h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm4.698 0h.94v.925h-.94zm2.819 0h.94v.925h-.94zm-19.734.925h.94v.925h-.94zm.942 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.738 133.799h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm3.759 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.954 133.799h.94v.925h-.94zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.873 104.666h5.638v5.549h-5.638zm24.431 0h5.638v5.549h-5.638zm-24.431 24.046h5.638v5.549h-5.638z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.282 106.054h2.82v2.774h-2.82zm24.431 0h2.819v2.774h-2.82zM28.282 130.1h2.82v2.774h-2.82zm5.637-20.347h.94v.925h-.94zm-1.878 1.85h.94v.924h-.94zm3.759-1.85h.94v.925h-.94zm-3.759 3.699h.94v.925h-.94zm5.637-3.699h.94v.925h-.94zm-5.637 5.549h.94v.925h-.94zm7.518-5.549h.94v.925h-.94zm-7.518 7.399h.94v.925h-.94zm9.397-7.399h.94v.925h-.94zm-9.397 9.248h.94v.925h-.94zm11.275-9.248h.94v.925h-.94zm-11.275 11.098h.94v.925h-.94zm13.153-11.098h.94v.925h-.94zm-13.153 12.948h.94v.925h-.94zm15.034-12.948h.94v.925h-.94zM32.041 124.55h.94v.925h-.94zm16.913-14.797h.94v.925h-.94zM32.041 126.4h.94v.925h-.94zm16.913 0h.94v.925h-.94zm0 .925h.94v.925h-.94zm0 .925h.94v.925h-.94zm0 .925h.94v.925h-.94zm3.759-1.85h.94v.925h-.94zm0 .925h.94v.925h-.94zm0 .925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.713 130.1h.94v.924h-.94zm-2.819-3.7h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 126.4h.94v.925h-.94zm.94 0h.94v.925h-.94zm-3.759 3.7h.94v.924h-.94zm.94 0h.94v.924h-.94zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.773 130.1h.94v.924h-.94zm-.939-1.85h.94v.925h-.94z",
    fill: "#9CA3AF"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.688 90.125H86.25a6.187 6.187 0 0 0-6.187 6.188v57.749a6.187 6.187 0 0 0 6.187 6.188h47.438a6.187 6.187 0 0 0 6.187-6.188v-57.75a6.187 6.187 0 0 0-6.187-6.187",
    fill: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 96,
    width: 48,
    height: 59
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.717 96.09H86.222v58.194h47.495z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.308 96.553H87.632a.93.93 0 0 0-.94.925v43.972c0 .511.421.925.94.925h44.676c.519 0 .94-.414.94-.925V97.478a.933.933 0 0 0-.94-.925",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.367 97.478H88.571a.93.93 0 0 0-.94.924v42.123c0 .511.42.925.94.925h42.796c.519 0 .94-.414.94-.925V98.402a.93.93 0 0 0-.94-.924",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.875 145.551a.46.46 0 0 0-.209-.349.8.8 0 0 0-.463-.125.9.9 0 0 0-.346.063.54.54 0 0 0-.227.172.4.4 0 0 0-.079.246.37.37 0 0 0 .053.2.5.5 0 0 0 .145.141q.09.056.193.093t.199.061l.317.082q.156.039.319.103.164.066.303.172a.8.8 0 0 1 .225.263q.088.157.088.376a.86.86 0 0 1-.143.49.95.95 0 0 1-.411.338 1.5 1.5 0 0 1-.649.124q-.365 0-.632-.116a1 1 0 0 1-.417-.328.95.95 0 0 1-.166-.508h.491q.015.176.115.294a.6.6 0 0 0 .258.173q.159.055.348.055a1 1 0 0 0 .369-.065.6.6 0 0 0 .258-.184.44.44 0 0 0 .093-.278.34.34 0 0 0-.082-.236.6.6 0 0 0-.221-.152 2 2 0 0 0-.312-.107l-.384-.104a1.5 1.5 0 0 1-.619-.313.7.7 0 0 1-.227-.546q0-.28.152-.49a1 1 0 0 1 .413-.325q.26-.118.587-.118.33 0 .582.116a1 1 0 0 1 .4.319.8.8 0 0 1 .152.463zm3.802.203h-.495a.76.76 0 0 0-.549-.61 1 1 0 0 0-.293-.043.9.9 0 0 0-.503.141.96.96 0 0 0-.349.414 1.6 1.6 0 0 0-.127.667q0 .396.127.669.128.273.351.413a.9.9 0 0 0 .499.139q.154 0 .292-.041a.78.78 0 0 0 .552-.603l.495.002a1.3 1.3 0 0 1-.153.441 1.24 1.24 0 0 1-.694.569q-.226.08-.495.08-.422 0-.752-.2a1.4 1.4 0 0 1-.52-.576 2 2 0 0 1-.189-.893q0-.52.19-.894t.521-.574q.33-.202.75-.202.259 0 .482.075.227.073.405.216.18.14.297.346.117.203.158.464m.84 2.193h-.521l1.17-3.249h.566l1.17 3.249h-.521l-.919-2.659h-.025zm.087-1.272h1.688v.412h-1.688zm5.39-1.977v3.249h-.451l-1.652-2.383h-.03v2.383h-.49v-3.249h.454l1.653 2.386h.03v-2.386zm1.897 0h.595l1.035 2.526h.038l1.034-2.526h.595v3.249h-.466v-2.351h-.03l-.959 2.347h-.387l-.958-2.349h-.03v2.353h-.467zm4.01 3.249v-3.249h2.037v.422h-1.547v.99h1.441v.42h-1.441v.995h1.566v.422z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.981 104.204h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 104.204h.94v.924h-.94zm.941 0h.94v.924h-.94zm1.88 0h.94v.924h-.94zm.94 0h.939v.924h-.939zm4.697 0h.94v.924h-.94zm2.818 0h.94v.924h-.94zm1.878 0h.94v.924h-.94zm.943 0h.939v.924h-.939zm-15.036.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 105.129h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm3.759 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm-15.036.925h.94v.925h-.94zm2.82 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm1.88 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 106.054h.94v.925h-.94zm1.879 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm-14.097.925h.94v.924h-.94zm.941 0h.94v.924h-.94zm2.82 0h.939v.924h-.939zm2.818 0h.94v.924h-.94zm1.879 0h.94v.924h-.94zm.94 0h.94v.924h-.94zm2.819 0h.939v.924h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 106.979h.94v.924h-.94zm-10.333.924h.94v.925h-.94zm.94 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm-14.097.925h.94v.925h-.94zm2.821 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm5.637 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.257 108.828h.939v.925h-.939zm.939 0h.94v.925h-.94zm-2.818 1.85h.94v.925h-.94zm2.818 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm-20.674.925h.939v.924h-.939zm.94 0h.94v.924h-.94zm5.637 0h.94v.924h-.94zm.941 0h.94v.924h-.94zm1.88 0h.94v.924h-.94zm2.818 0h.939v.924h-.939zm1.88 0h.94v.924h-.94zm2.818 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm.941 0h.939v.924h-.939zm2.82 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 111.603h.939v.924h-.939zm.941 0h.94v.924h-.94zm2.817 0h.94v.924h-.94zm.941 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm-28.19.924h.939v.925h-.939zm1.882 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.163 112.527h.94v.925h-.94zm3.757 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm1.88 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm3.756 0h.94v.925h-.94zm1.883 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 112.527h.939v.925h-.939zm2.82 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm-30.069.925h.94v.925h-.94zm6.579 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm2.817 0h.94v.925h-.94zm2.821 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 113.452h.94v.925h-.94zm1.879 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm4.699 0h.94v.925h-.94zm-25.372.925h.94v.925h-.94zm.941 0h.94v.925h-.94zm2.82 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.163 114.377h.94v.925h-.94zm1.88 0h.94v.925h-.94zm3.758 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm.94 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 114.377h.94v.925h-.94zm1.881 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm4.696 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm2.82 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.653 114.377h.94v.925h-.94zm.941 0h.939v.925h-.939zm-29.13.925h.94v.925h-.94zm.941 0h.94v.925h-.94zm2.82 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.163 115.302h.94v.925h-.94zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 115.302h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm2.821 0h.94v.925h-.94zm2.818 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 115.302h.94v.925h-.94zm.943 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.879 0h.939v.925h-.939zm-27.251.925h.94v.925h-.94zm4.699 0h.94v.925h-.94zm2.818 0h.94v.925h-.94zm4.7 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 116.227h.94v.925h-.94zm.941 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm3.756 0h.94v.925h-.94zm2.821 0h.939v.925h-.939zm1.878 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm-30.069.925h.94v.925h-.94zm3.761 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm1.877 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm2.818 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm3.758 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm2.82 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 117.152h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.773 117.152h.94v.925h-.94zm2.821 0h.939v.925h-.939zm-27.251.925h.939v.925h-.939zm.94 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm3.756 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm3.758 0h.94v.925h-.94zm3.758 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 118.077h.94v.925h-.94zm1.883 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 118.077h.939v.925h-.939zm1.878 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm-28.189.924h.94v.925h-.94zm1.879 0h.939v.925h-.939zm2.82 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm4.698 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm1.88 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm3.756 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.836 119.001h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.773 119.001h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-26.308.925h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.163 119.926h.94v.925h-.94zm3.757 0h.94v.925h-.94zm1.881 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm6.577 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.257 119.926h.939v.925h-.939zm.939 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.943 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm-24.431.925h.94v.925h-.94zm1.879 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.981 120.851h.94v.925h-.94zm1.88 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm2.821 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 120.851h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.257 120.851h.939v.925h-.939zm.939 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm4.699 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.773 120.851h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm-29.13.925h.94v.925h-.94zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.343 121.776h.939v.925h-.939zm.94 0h.94v.925h-.94zm3.76 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.981 121.776h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 121.776h.94v.925h-.94zm1.881 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm3.758 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 121.776h.94v.925h-.94zm2.818 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 121.776h.94v.925h-.94zm.943 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.879 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.653 121.776h.94v.925h-.94zm.941 0h.939v.925h-.939zm-29.13.925h.94v.925h-.94zm2.819 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm3.758 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm3.758 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm2.819 0h.939v.925h-.939zm1.88 0h.939v.925h-.939zm3.756 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm1.879 0h.939v.925h-.939zm-29.13.925h.94v.925h-.94zm2.819 0h.94v.925h-.94zm.942 0h.939v.925h-.939zm2.818 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.981 123.626h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 123.626h.94v.925h-.94zm2.821 0h.94v.925h-.94zm.94 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 123.626h.94v.925h-.94zm2.821 0h.94v.925h-.94zm1.879 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.257 123.626h.939v.925h-.939zm1.88 0h.939v.925h-.939zm2.82 0h.94v.925h-.94zm3.758 0h.939v.925h-.939zm2.818 0h.94v.925h-.94zm-30.069.924h.94v.925h-.94zm8.456 0h.94v.925h-.94zm.941 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.94 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 124.55h.94v.925h-.94zm2.821 0h.94v.925h-.94zm1.879 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 124.55h.94v.925h-.94zm.943 0h.939v.925h-.939zm-22.553.926h.94v.924h-.94zm1.879 0h.939v.924h-.939zm.94 0h.94v.924h-.94zm3.76 0h.94v.924h-.94zm6.575 0h.94v.924h-.94zm1.881 0h.94v.924h-.94zm3.758 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm.941 0h.939v.924h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 125.476h.94v.924h-.94zm3.762 0h.94v.924h-.94zm1.879 0h.939v.924h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.653 125.476h.94v.924h-.94zm.941 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm-30.069.924h.94v.925h-.94zm1.879 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm5.637 0h.94v.925h-.94zm4.698 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 126.4h.94v.925h-.94zm5.641 0h.939v.925h-.939zm-19.734.925h.94v.925h-.94zm1.88 0h.94v.925h-.94zm4.698 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 127.325h.94v.925h-.94zm1.879 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm8.457 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-21.613.925h.94v.925h-.94zm2.821 0h.94v.925h-.94zm5.637 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm6.579 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm-20.674.925h.94v.925h-.94zm.941 0h.94v.925h-.94zm3.757 0h.94v.925h-.94zm3.76 0h.94v.925h-.94zm.94 0h.94v.925h-.94zm1.878 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 129.175h.94v.925h-.94zm5.641 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.653 129.175h.94v.925h-.94zm.941 0h.939v.925h-.939zm.939 0h.94v.925h-.94zm-22.552.925h.94v.924h-.94zm8.458 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.378 130.1h.94v.924h-.94zm2.818 0h.94v.924h-.94zm7.519 0h.939v.924h-.939zm1.879 0h.939v.924h-.939zm.939 0h.94v.924h-.94zm-22.552.924h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 131.024h.94v.925h-.94zm3.761 0h.939v.925h-.939zm1.878 0h.939v.925h-.939zm4.698 0h.939v.925h-.939zm1.88 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 131.024h.94v.925h-.94zm1.883 0h.94v.925h-.94zm2.816 0h.94v.925h-.94zm1.88 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm-21.613.925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.92 131.949h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm3.758 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm6.575 0h.94v.925h-.94zm1.883 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 131.949h.939v.925h-.939zm3.758 0h.94v.925h-.94zm-18.792.925h.94v.925h-.94zm2.82 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 132.874h.94v.925h-.94zm.941 0h.939v.925h-.939zm2.819 0h.94v.925h-.94zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.257 132.874h.939v.925h-.939zm.939 0h.94v.925h-.94zm.941 0h.939v.925h-.939zm4.699 0h.94v.925h-.94zm2.817 0h.94v.925h-.94zm-19.733.925h.94v.925h-.94zm.941 0h.94v.925h-.94zm.94 0h.939v.925h-.939zm.94 0h.94v.925h-.94zm.94 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.618 133.799h.94v.925h-.94zm3.76 0h.94v.925h-.94zm3.759 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.074 133.799h.94v.925h-.94zm.943 0h.939v.925h-.939zm.94 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 133.799h.939v.925h-.939zm3.758 0h.94v.925h-.94zm.941 0h.939v.925h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.934 104.666h5.637v5.549h-5.637zm24.432 0h5.638v5.549h-5.638zm-24.432 24.046h5.637v5.549h-5.637z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.343 106.054h2.819v2.774h-2.819zm24.43 0h2.819v2.774h-2.819zM96.343 130.1h2.819v2.774h-2.819zm5.638-20.347h.94v.925h-.94zm-1.877 1.85h.939v.924h-.939zm3.757-1.85h.94v.925h-.94zm-3.757 3.699h.939v.925h-.939zm5.637-3.699h.94v.925h-.94zm-5.637 5.549h.939v.925h-.939zm7.514-5.549h.94v.925h-.94zm-7.514 7.399h.939v.925h-.939zm9.395-7.399h.94v.925h-.94zm-9.395 9.248h.939v.925h-.939zm11.274-9.248h.94v.925h-.94zm-11.274 11.098h.939v.925h-.939zm13.153-11.098h.939v.925h-.939zm-13.153 12.948h.939v.925h-.939zm15.033-12.948h.939v.925h-.939zm-15.033 14.797h.939v.925h-.939zm16.913-14.797h.939v.925h-.939zM100.104 126.4h.939v.925h-.939zm16.913 0h.939v.925h-.939zm0 .925h.939v.925h-.939zm0 .925h.939v.925h-.939zm0 .925h.939v.925h-.939zm3.756-1.85h.94v.925h-.94zm0 .925h.94v.925h-.94zm0 .925h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.773 130.1h.94v.924h-.94zm-2.816-3.7h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 126.4h.939v.925h-.939zm.941 0h.94v.925h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.773 126.4h.94v.925h-.94zm-3.756 3.7h.939v.924h-.939zm.94 0h.94v.924h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.895 130.1h.939v.924h-.939zm.941 0h.94v.924h-.94zm-.941-1.85h.939v.925h-.939z",
    fill: "#9CA3AF"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.75 90.125h-47.438a6.187 6.187 0 0 0-6.187 6.188v57.749a6.187 6.187 0 0 0 6.187 6.188h47.438a6.19 6.19 0 0 0 6.188-6.188v-57.75a6.19 6.19 0 0 0-6.188-6.187",
    fill: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 96,
    width: 48,
    height: 59
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.779 96.09h-47.495v58.194h47.495z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.369 96.56h-44.676a.94.94 0 0 0-.94.94v44.676a.94.94 0 0 0 .94.939h44.676a.94.94 0 0 0 .939-.939V97.5a.94.94 0 0 0-.939-.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.429 97.5h-42.797a.94.94 0 0 0-.94.94v42.796c0 .519.421.94.94.94h42.797a.94.94 0 0 0 .939-.94V98.44a.94.94 0 0 0-.939-.94",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.369 144.055h-44.676a.94.94 0 0 0-.94.939v7.432c0 .519.421.94.94.94h44.676a.94.94 0 0 0 .939-.94v-7.432a.94.94 0 0 0-.939-.939",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.939 147.257a.47.47 0 0 0-.21-.349.8.8 0 0 0-.463-.125.9.9 0 0 0-.346.063.54.54 0 0 0-.227.172.4.4 0 0 0-.079.246.36.36 0 0 0 .054.199.5.5 0 0 0 .144.142q.091.056.194.093t.198.061l.317.082q.156.038.319.103.164.066.303.172a.77.77 0 0 1 .313.639.87.87 0 0 1-.143.49.95.95 0 0 1-.411.338 1.5 1.5 0 0 1-.649.124 1.6 1.6 0 0 1-.631-.116.97.97 0 0 1-.417-.328.95.95 0 0 1-.167-.508h.492a.5.5 0 0 0 .114.293.6.6 0 0 0 .259.173q.158.056.347.056a1 1 0 0 0 .37-.065.63.63 0 0 0 .257-.184.44.44 0 0 0 .093-.278.34.34 0 0 0-.082-.236.6.6 0 0 0-.221-.153 2 2 0 0 0-.312-.106l-.384-.105a1.5 1.5 0 0 1-.619-.312.7.7 0 0 1-.227-.546q0-.281.153-.49a1 1 0 0 1 .412-.325q.26-.118.587-.118.33 0 .582.116.255.116.4.319a.8.8 0 0 1 .153.463zm3.801.203h-.495a.75.75 0 0 0-.296-.484.8.8 0 0 0-.253-.127 1 1 0 0 0-.293-.042.9.9 0 0 0-.503.141.96.96 0 0 0-.349.414 1.6 1.6 0 0 0-.127.666q0 .397.127.67a.95.95 0 0 0 .351.412q.222.14.499.14.154 0 .292-.041a.9.9 0 0 0 .253-.126.76.76 0 0 0 .299-.477l.495.001q-.039.24-.153.441a1.2 1.2 0 0 1-.291.346 1.3 1.3 0 0 1-.403.224 1.5 1.5 0 0 1-.495.079q-.422 0-.752-.2a1.4 1.4 0 0 1-.52-.576 1.96 1.96 0 0 1-.189-.893q0-.52.19-.893.19-.375.521-.574.33-.202.75-.202.259 0 .483.075a1.24 1.24 0 0 1 .859 1.026m.84 2.193h-.521l1.17-3.249h.566l1.169 3.249h-.52l-.919-2.659h-.025zm.087-1.273h1.688v.413h-1.688zm5.389-1.976v3.249h-.451l-1.651-2.383h-.03v2.383h-.491v-3.249h.454l1.653 2.386h.03v-2.386zm1.897 0h.595l1.035 2.525h.038l1.034-2.525h.595v3.249h-.466v-2.351h-.03l-.959 2.346h-.387l-.958-2.348h-.03v2.353h-.467zm4.01 3.249v-3.249H188v.422h-1.547v.99h1.441v.42h-1.441v.995h1.566v.422z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.043 104.333h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 104.333h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm1.878 0h.939v.94h-.939zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.438 104.333h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 104.333h.94v.94h-.94zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.197 104.333h.94v.94h-.94zm1.881 0h.94v.94h-.94zm-13.157.94h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm4.696 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm-15.035.94h.94v.94h-.94zm2.818 0h.94v.94h-.94zm2.821 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 106.213h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.438 106.213h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.942 0h.94v.94h-.94zm1.878 0h.939v.94h-.939zm.941 0h.94v.94h-.94zm-10.337.94h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 107.153h.94v.94h-.94zm.94 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm1.878 0h.939v.94h-.939zm-9.396.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.378 108.092h.94v.94h-.94zm1.881 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm-10.337.94h.94v.939h-.94zm1.879 0h.94v.939h-.94zm2.818 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm-10.335 1.879h.94v.94h-.94zm3.759 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.939v.94h-.939zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.438 110.911h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 110.911h.94v.94h-.94zm3.761 0h.94v.94h-.94zm-12.217.94h.94v.94h-.94zm2.821 0h.939v.94h-.939zm2.819 0h.94v.94h-.94zm8.455 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm1.882 0h.94v.94h-.94zm1.877 0h.94v.94h-.94zm-27.249.94h.939v.939h-.939zm1.881 0h.939v.939h-.939zm2.818 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 112.791h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.921 112.791h.94v.939h-.94zm4.699 0h.94v.939h-.94zm1.881 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.438 112.791h.94v.939h-.94zm2.821 0h.94v.939h-.94zm3.758 0h.939v.939h-.939zm1.88 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 112.791h.94v.939h-.94zm.941 0h.94v.939h-.94zm-27.25.939h.94v.94h-.94zm6.578 0h.939v.94h-.939zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.921 113.73h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.88 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 113.73h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm-25.372.94h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.939v.94h-.939zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.225 114.67h.939v.94h-.939zm1.878 0h.939v.94h-.939zm4.699 0h.94v.94h-.94zm3.758 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm2.821 0h.94v.94h-.94zm1.878 0h.939v.94h-.939zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 114.67h.94v.94h-.94zm-29.129.939h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.698 0h.939v.94h-.939zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.939v.94h-.939zm4.699 0h.94v.94h-.94zm1.878 0h.939v.94h-.939zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 115.609h.94v.94h-.94zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 115.609h.94v.94h-.94zm-28.188.94h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.225 116.549h.939v.94h-.939zm1.878 0h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 116.549h.94v.94h-.94zm3.759 0h.94v.94h-.94zm.941 0h.939v.94h-.939zm3.756 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm1.878 0h.939v.94h-.939zm2.819 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 116.549h.94v.94h-.94zm3.759 0h.94v.94h-.94zm-26.307.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.225 117.489h.939v.94h-.939zm3.757 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.921 117.489h.94v.94h-.94zm1.881 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.939v.94h-.939zm3.757 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.82 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 117.489h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm-29.129.939h.94v.94h-.94zm.94.001h.94v.939h-.94zm1.879-.001h.939v.94h-.939zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.225 118.428h.939v.94h-.939zm2.818 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 118.428h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.88.001h.939v.939h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 118.428h.94v.94h-.94zm7.517 0h.939v.94h-.939zm1.88 0h.939v.94h-.939zm1.88 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941.001h.94v.939h-.94zm1.877-.001h.94v.94h-.94zm-26.307.94h.94v.94h-.94zm3.757 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 119.368h.94v.94h-.94zm4.7 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 119.368h.94v.94h-.94zm1.881 0h.94v.94h-.94zm1.877 0h.94v.94h-.94zm3.759 0h.939v.94h-.939zm3.76 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 119.368h.94v.94h-.94zm.941 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 119.368h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 119.368h.94v.94h-.94zm-30.068.94h.94v.939h-.94zm.94 0h.94v.939h-.94zm.94 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.344 120.308h.939v.939h-.939zm7.517 0h.94v.939h-.94zm.941 0h.94v.939h-.94zm2.818 0h.94v.939h-.94zm3.758 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 120.308h.94v.939h-.94zm2.82 0h.939v.939h-.939zm.941 0h.94v.939h-.94zm1.878 0h.94v.939h-.94zm.941 0h.94v.939h-.94zm4.696 0h.94v.939h-.94zm-30.068.939h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.821 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm2.821 0h.94v.94h-.94zm1.878 0h.939v.94h-.939zm1.88 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.877 0h.94v.94h-.94zm-30.068.94h.94v.94h-.94zm2.819 0h.939v.94h-.939zm1.881 0h.939v.94h-.939zm1.878 0h.939v.94h-.939zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.741 122.187h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.438 122.187h.94v.94h-.94zm3.759 0h.94v.94h-.94zm.94 0h.939v.94h-.939zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.017 122.187h.939v.94h-.939zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.877 0h.94v.94h-.94zm-30.068.94h.94v.94h-.94zm.94 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.344 123.127h.939v.94h-.939zm3.759 0h.939v.94h-.939zm3.758 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.939v.94h-.939zm.941 0h.94v.94h-.94zm1.877 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm3.756 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm-29.129.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.405 124.066h.94v.94h-.94zm4.698 0h.939v.94h-.939zm2.818 0h.94v.94h-.94zm2.82 0h.94v.94h-.94zm3.76 0h.94v.94h-.94zm1.877 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 124.066h.94v.94h-.94zm4.7 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 124.066h.94v.94h-.94zm.941 0h.94v.94h-.94zm-27.25.94h.94v.94h-.94zm9.396 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm3.76 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.438 125.006h.94v.94h-.94zm2.821 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.197 125.006h.94v.94h-.94zm.94 0h.939v.94h-.939zm.941 0h.94v.94h-.94zm-22.553.94h.94v.94h-.94zm1.88 0h.94v.94h-.94zm4.698 0h.939v.94h-.939zm1.879 0h.94v.94h-.94zm8.456 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 125.946h.94v.94h-.94zm2.82 0h.939v.94h-.939zm5.638 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 125.946h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 125.946h.94v.94h-.94zm-30.068.939h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.939v.94h-.939zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.225 126.885h.939v.94h-.939zm1.878 0h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 126.885h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.921 126.885h.94v.94h-.94zm1.881 0h.94v.94h-.94zm3.758 0h.939v.94h-.939zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm9.395 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 126.885h.94v.94h-.94zm-22.55.94h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.982 127.825h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.921 127.825h.94v.939h-.94zm.94 0h.94v.939h-.94zm2.821 0h.939v.939h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 127.825h.94v.939h-.94zm1.881 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.438 127.825h.94v.939h-.94zm3.759 0h.94v.939h-.94zm.94 0h.939v.939h-.939zm6.579 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 127.825h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 127.825h.94v.939h-.94zm-21.611.939h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.821 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 128.764h.94v.94h-.94zm.94 0h.939v.94h-.939zm.941 0h.94v.94h-.94zm1.877 0h.94v.94h-.94zm1.881 0h.94v.94h-.94zm8.457 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 128.764h.94v.94h-.94zm-21.611.94h.94v.94h-.94zm3.759 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm1.878 0h.939v.94h-.939zm2.818 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 129.704h.94v.94h-.94zm2.82 0h.939v.94h-.939zm5.638 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 129.704h.94v.94h-.94zm-20.672.94h.94v.939h-.94zm3.759 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm2.818 0h.94v.94h-.94zm2.821 0h.94v.939h-.94zm7.516 0h.94v.939h-.94zm1.879 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 130.644h.94v.939h-.94zm-17.852.939h.94v.94h-.94zm4.697 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.197 131.583h.94v.94h-.94zm.94 0h.939v.94h-.939zm1.88 0h.939v.94h-.939zm1.88 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 131.583h.94v.94h-.94zm.941 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 131.583h.94v.94h-.94zm-20.672.94h.94v.94h-.94zm3.759 0h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62 132.523h.94v.94h-.94zm1.881 0h.94v.94h-.94zm1.877 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 132.523h.94v.94h-.94zm1.88 0h.94v.94h-.94zm5.637 0h.94v.94h-.94zm1.882 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 132.523h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.593 132.523h.94v.94h-.94zm-21.611.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.921 133.463h.94v.94h-.94zm2.82 0h.94v.94h-.94zm.941 0h.939v.94h-.939zm3.756 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.317 133.463h.94v.94h-.94zm1.88 0h.94v.94h-.94zm7.519 0h.94v.94h-.94zm-19.734.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.921 134.402h.94v.94h-.94zm.94 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.741 134.402h.94v.94h-.94zm.941 0h.939v.94h-.939zm3.756 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm.94 0h.939v.94h-.939zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.017 134.402h.939v.94h-.939zm.939 0h.94v.94h-.94zm3.76 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.654 134.402h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.994 104.803h5.638v5.638h-5.638zm24.434 0h5.638v5.638h-5.638zm-24.434 24.431h5.638v5.638h-5.638z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.405 106.213h2.819v2.819h-2.819zm24.429 0h2.819v2.819h-2.819zm-24.429 24.431h2.819v2.819h-2.819zm5.638-20.672h.94v.939h-.94zm-1.879 1.879h.94v.94h-.94zm3.757-1.879h.94v.939h-.94zm-3.757 3.758h.94v.94h-.94zm5.638-3.758h.94v.939h-.94zm-5.638 5.637h.94v.94h-.94zm7.518-5.637h.939v.939h-.939zm-7.518 7.517h.94v.94h-.94zm9.396-7.517h.939v.939h-.939zm-9.396 9.396h.94v.94h-.94zm11.274-9.396h.94v.939h-.94zm-11.274 11.275h.94v.94h-.94zm13.153-11.275h.94v.939h-.94zm-13.153 13.155h.94v.94h-.94zm15.033-13.155h.94v.939h-.94zm-15.033 15.034h.94v.94h-.94zm16.914-15.034h.94v.939h-.94zm-16.914 16.913h.94v.94h-.94zm16.914 0h.94v.94h-.94zm0 .94h.94v.939h-.94zm0 .939h.94v.94h-.94zm0 .94h.94v.94h-.94zm3.756-1.879h.94v.939h-.94zm0 .939h.94v.94h-.94zm0 .94h.94v.94h-.94zm0 .94h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.017 126.885h.939v.94h-.939zm.939 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.834 126.885h.94v.94h-.94zm-3.756 3.759h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.017 130.644h.939v.939h-.939zm.939 0h.94v.94h-.94zm.941 0h.94v.939h-.94zm-.941-1.88h.94v.94h-.94z",
    fill: "#9CA3AF"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M269.813 90.125h-47.438a6.187 6.187 0 0 0-6.187 6.188v57.749a6.187 6.187 0 0 0 6.187 6.188h47.438a6.187 6.187 0 0 0 6.187-6.188v-57.75a6.187 6.187 0 0 0-6.187-6.187",
    fill: "#F9FAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_214_6090",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 96,
    width: 48,
    height: 59
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M269.842 96.09h-47.495v58.194h47.495z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_214_6090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.431 106.811h-44.676a.94.94 0 0 0-.94.94v44.676a.94.94 0 0 0 .94.939h44.676a.94.94 0 0 0 .94-.939v-44.676a.94.94 0 0 0-.94-.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.492 107.75h-42.796a.94.94 0 0 0-.94.94v42.797a.94.94 0 0 0 .94.939h42.796a.94.94 0 0 0 .94-.939V108.69a.94.94 0 0 0-.94-.94",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.431 96.56h-44.676a.94.94 0 0 0-.94.94v7.431c0 .519.421.94.94.94h44.676a.94.94 0 0 0 .94-.94V97.5a.94.94 0 0 0-.94-.94",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.003 99.762a.46.46 0 0 0-.209-.349.8.8 0 0 0-.463-.126.85.85 0 0 0-.346.064.53.53 0 0 0-.227.171.4.4 0 0 0-.08.246q0 .116.054.2a.5.5 0 0 0 .145.141q.09.055.193.094.103.036.199.06l.317.082q.156.038.319.104.164.064.303.171a.77.77 0 0 1 .312.639.86.86 0 0 1-.142.49.95.95 0 0 1-.411.338 1.5 1.5 0 0 1-.649.124q-.365 0-.632-.116a1 1 0 0 1-.417-.328.95.95 0 0 1-.166-.508h.491q.015.177.115.294a.6.6 0 0 0 .258.173q.159.055.348.055a1 1 0 0 0 .369-.065.6.6 0 0 0 .257-.184.43.43 0 0 0 .094-.277.34.34 0 0 0-.083-.237.6.6 0 0 0-.22-.152 2 2 0 0 0-.313-.106l-.384-.105a1.5 1.5 0 0 1-.618-.313.7.7 0 0 1-.227-.545q0-.281.152-.491.153-.209.413-.325t.587-.117q.33 0 .582.115a1 1 0 0 1 .4.319.8.8 0 0 1 .152.464zm3.802.203h-.495a.8.8 0 0 0-.106-.28.8.8 0 0 0-.443-.331 1 1 0 0 0-.294-.043.9.9 0 0 0-.502.141.96.96 0 0 0-.35.414 1.6 1.6 0 0 0-.126.667q0 .396.126.669.129.273.351.413a.9.9 0 0 0 .5.139 1 1 0 0 0 .292-.041.9.9 0 0 0 .252-.125.8.8 0 0 0 .19-.202.8.8 0 0 0 .11-.276l.495.002a1.4 1.4 0 0 1-.154.441 1.24 1.24 0 0 1-.693.569q-.228.08-.495.08-.423 0-.752-.2a1.4 1.4 0 0 1-.521-.576 1.96 1.96 0 0 1-.188-.893q0-.52.19-.894t.52-.574q.33-.201.751-.201.258 0 .482.074.225.074.405.216.179.14.296.346.117.203.159.465m.839 2.192h-.52l1.169-3.249h.566l1.17 3.249h-.521l-.918-2.659h-.026zm.087-1.272h1.688v.412h-1.688zm5.389-1.977v3.249h-.45l-1.652-2.383h-.03v2.383h-.49v-3.249h.454l1.653 2.386h.03v-2.386zm1.898 0h.595l1.034 2.526h.038l1.035-2.526h.595v3.249h-.467v-2.351h-.03l-.958 2.346h-.387l-.959-2.348h-.03v2.353h-.466zm4.009 3.249v-3.249h2.037v.422h-1.546v.99h1.44v.42h-1.44v.995h1.565v.422z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.106 114.584h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 114.584h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.881 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.563 114.584h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 114.584h.94v.94h-.94zm.94 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.261 114.584h.939v.94h-.939zm1.882 0h.939v.94h-.939zm-13.159.94h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm4.698 0h.94v.94h-.94zm2.819 0h.939v.94h-.939zm1.882 0h.939v.94h-.939zm-15.037.94h.94v.94h-.94zm2.819 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 116.464h.939v.94h-.939zm1.88 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.941 0h.939v.94h-.939zm-10.338.939h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.744 117.403h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 117.403h.939v.94h-.939zm.942 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 117.403h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm-9.397.94h.939v.94h-.939zm5.637 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.821 0h.939v.94h-.939zm-10.338.94h.939v.939h-.939zm1.878 0h.939v.939h-.939zm2.821 0h.94v.939h-.94zm1.878 0h.94v.939h-.94zm-10.337 1.879h.94v.94h-.94zm3.76 0h.939v.94h-.939zm1.878 0h.939v.94h-.939zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.563 121.162h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 121.162h.94v.94h-.94zm.94 0h.94v.94h-.94zm3.761 0h.939v.94h-.939zm-12.218.94h.94v.939h-.94zm2.819 0h.94v.939h-.94zm2.819 0h.94v.939h-.94zm8.457 0h.939v.939h-.939zm1.88 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm-27.252.939h.94v.94h-.94zm1.881 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 123.041h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 123.041h.94v.94h-.94zm4.699 0h.939v.94h-.939zm1.88 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9 123.041h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.838 123.041h.94v.94h-.94zm-27.248.94h.94v.94h-.94zm6.576 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 123.981h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 123.981h.939v.94h-.939zm2.821 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 123.981h.94v.94h-.94zm2.819 0h.939v.94h-.939zm1.882 0h.939v.94h-.939zm2.817 0h.94v.94h-.94zm-25.37.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.528 124.92h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.944 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.287 124.92h.94v.94h-.94zm1.879 0h.94v.94h-.94zm4.699 0h.94v.94h-.94zm3.76 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.941 0h.939v.94h-.939zm1.877 0h.939v.94h-.939zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 124.92h.94v.94h-.94zm-29.128.94h.94v.94h-.94zm1.88 0h.939v.94h-.939zm4.696 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.818 0h.939v.94h-.939zm.942 0h.94v.94h-.94zm4.697 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.941 0h.939v.94h-.939zm1.877 0h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9 125.86h.94v.94h-.94zm2.818 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm-28.188.94h.939v.94h-.939zm1.88 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.287 126.8h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 126.8h.94v.94h-.94zm3.76 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm3.76 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 126.8h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.818 0h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9 126.8h.94v.94h-.94zm3.758 0h.94v.94h-.94zm-26.308.939h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.287 127.739h.94v.94h-.94zm3.758 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 127.739h.94v.94h-.94zm1.881 0h.94v.94h-.94zm2.818 0h.939v.94h-.939zm.942 0h.94v.94h-.94zm3.757 0h.94v.94h-.94zm1.879 0h.939v.94h-.939zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.02 127.739h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9 127.739h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.838 127.739h.94v.94h-.94zm1.88 0h.94v.94h-.94zm-29.128.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.528 128.679h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.944 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.287 128.679h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 128.679h.94v.94h-.94zm1.88 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 128.679h.939v.94h-.939zm7.519 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm-26.308.94h.939v.939h-.939zm3.756 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 129.619h.94v.939h-.94zm4.699 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 129.619h.939v.939h-.939zm1.88 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm3.76 0h.94v.939h-.94zm3.758 0h.94v.939h-.94zm.94 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.838 129.619h.94v.939h-.94zm.941 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 129.619h.94v.939h-.94zm.94 0h.94v.939h-.94zm-30.068.94h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.528 130.559h.94v.939h-.94zm.942 0h.939v.939h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.406 130.559h.94v.939h-.94zm7.519 0h.94v.939h-.94zm.94 0h.94v.939h-.94zm2.818 0h.939v.939h-.939zm3.759 0h.94v.939h-.94zm.94 0h.94v.939h-.94zm2.82 0h.94v.939h-.94zm.941 0h.939v.939h-.939zm1.877 0h.939v.939h-.939zm.94 0h.94v.939h-.94zm4.698 0h.94v.939h-.94zm-30.068.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.528 131.498h.94v.94h-.94zm2.822 0h.939v.94h-.939zm3.756 0h.94v.94h-.94zm2.819 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm2.82 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.02 131.498h.939v.94h-.939zm.94 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm-30.068.94h.94v.939h-.94zm2.816 0h.94v.939h-.94zm1.881 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm3.759 0h.94v.939h-.94zm.94 0h.94v.939h-.94zm.94 0h.939v.939h-.939zm1.878 0h.939v.939h-.939zm1.88 0h.94v.939h-.94zm.941 0h.94v.939h-.94zm3.757 0h.939v.939h-.939zm.941 0h.94v.939h-.94zm.941 0h.939v.939h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.081 132.438h.94v.939h-.94zm3.757 0h.94v.939h-.94zm.941 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm-30.068.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.528 133.377h.94v.94h-.94zm.942 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.406 133.377h.94v.94h-.94zm3.76 0h.94v.94h-.94zm3.759 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm2.82 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.563 133.377h.94v.94h-.94zm1.879 0h.94v.94h-.94zm2.819 0h.939v.94h-.939zm1.882 0h.939v.94h-.939zm3.757 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.838 133.377h.94v.94h-.94zm1.88 0h.94v.94h-.94zm-29.128.94h.94v.94h-.94zm1.88 0h.939v.94h-.939zm4.696 0h.94v.94h-.94zm2.818 0h.94v.94h-.94zm2.821 0h.939v.94h-.939zm3.758 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm4.699 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.02 134.317h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9 134.317h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.838 134.317h.94v.94h-.94zm-27.248.939h.94v.94h-.94zm9.394 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm1.88 0h.939v.94h-.939zm3.758 0h.94v.94h-.94zm.941 0h.94v.94h-.94zm2.818 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.261 135.256h.939v.94h-.939zm.941 0h.94v.94h-.94zm.941 0h.939v.94h-.939zm-22.553.94h.94v.94h-.94zm1.88 0h.939v.94h-.939zm4.696 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm8.459 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 136.196h.94v.94h-.94zm.94 0h.94v.94h-.94zm2.82 0h.94v.94h-.94zm5.636 0h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 136.196h.94v.94h-.94zm.94 0h.94v.94h-.94zm-30.068.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.528 137.136h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.944 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.287 137.136h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 137.136h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 137.136h.94v.94h-.94zm1.881 0h.94v.94h-.94zm3.76 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 137.136h.94v.94h-.94zm1.88 0h.94v.94h-.94zm9.396 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm-22.552.94h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.045 138.076h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 138.076h.94v.939h-.94zm.941 0h.94v.939h-.94zm2.819 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 138.076h.939v.939h-.939zm1.88 0h.94v.939h-.94zm.941 0h.94v.939h-.94zm3.757 0h.939v.939h-.939zm.941 0h.94v.939h-.94zm6.577 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 138.076h.94v.939h-.94zm.94 0h.94v.939h-.94zm-21.613.939h.94v.94h-.94zm1.88 0h.94v.94h-.94zm2.819 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 139.015h.939v.94h-.939zm.942 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.563 139.015h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.88 0h.94v.94h-.94zm8.457 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 139.015h.94v.94h-.94zm-21.612.94h.94v.939h-.94zm3.759 0h.94v.939h-.94zm1.879 0h.94v.939h-.94zm1.881 0h.94v.939h-.94zm2.817 0h.94v.939h-.94zm.94 0h.94v.939h-.94zm2.82 0h.94v.939h-.94zm5.636 0h.94v.939h-.94zm.941 0h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 139.955h.94v.939h-.94zm-20.673.94h.94v.939h-.94zm3.76 0h.939v.939h-.939zm1.878 0h.939v.939h-.939zm2.821 0h.94v.939h-.94zm2.818 0h.94v.939h-.94zm7.516 0h.94v.939h-.94zm1.88 0h.94v.939h-.94zm.94 0h.94v.939h-.94zm-17.853.939h.939v.94h-.939zm4.699 0h.94v.94h-.94zm1.878 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.261 141.834h.939v.94h-.939zm.941 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.838 141.834h.94v.94h-.94zm.941 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 141.834h.94v.94h-.94zm-20.673.94h.94v.94h-.94zm3.76 0h.939v.94h-.939zm.939 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.683 142.774h.939v.94h-.939zm1.88 0h.94v.94h-.94zm1.879 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.939v.94h-.939zm5.639 0h.94v.94h-.94zm1.879 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 142.774h.94v.94h-.94zm.94 0h.94v.94h-.94zm-21.613.939h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 143.713h.94v.94h-.94zm2.821 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm3.76 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.442 143.713h.94v.94h-.94zm.94 0h.94v.94h-.94zm1.879 0h.939v.94h-.939zm7.518 0h.94v.94h-.94zm-19.734.94h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.984 144.653h.94v.94h-.94zm.941 0h.94v.94h-.94zm.94 0h.94v.94h-.94zm.94 0h.939v.94h-.939zm.939 0h.94v.94h-.94zm3.76 0h.94v.94h-.94zm3.757 0h.939v.94h-.939zm.941 0h.94v.94h-.94zm.941 0h.939v.94h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.081 144.653h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.02 144.653h.939v.94h-.939zm3.759 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.718 144.653h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.058 115.054h5.638v5.638h-5.638zm24.433 0h5.638v5.638h-5.638zm-24.433 24.431h5.638v5.638h-5.638z",
    stroke: "#9CA3AF",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.47 116.464h2.819v2.819h-2.819zm24.43 0h2.819v2.819H256.9zm-24.43 24.431h2.819v2.818h-2.819zm5.636-20.673h.94v.94h-.94zm-1.878 1.88h.939v.939h-.939zm3.756-1.88h.94v.94h-.94zm-3.756 3.759h.939v.94h-.939zm5.637-3.759h.94v.94h-.94zm-5.637 5.638h.939v.94h-.939zm7.516-5.638h.94v.94h-.94zm-7.516 7.517h.939v.94h-.939zm9.397-7.517h.94v.94h-.94zm-9.397 9.397h.939v.939h-.939zm11.276-9.397h.94v.94h-.94zm-11.276 11.276h.939v.94h-.939zm13.154-11.276h.94v.94h-.94zm-13.154 13.155h.939v.94h-.939zm15.033-13.155h.939v.94h-.939zm-15.033 15.034h.939v.94h-.939zm16.915-15.034h.939v.94h-.939zm-16.915 16.914h.939v.94h-.939zm16.915 0h.939v.94h-.939zm0 .94h.939v.939h-.939zm0 .939h.939v.94h-.939zm0 .94h.939v.939h-.939zm3.757-1.879h.94v.939h-.94zm0 .939h.94v.94h-.94zm0 .94h.94v.939h-.94zm0 .94h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.081 137.136h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.02 137.136h.939v.94h-.939zm.94 0h.94v.94h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9 137.136h.94v.94h-.94zm-3.757 3.759h.939v.939h-.939z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.081 140.895h.94v.939h-.94z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.02 140.895h.939v.939h-.939zm.94 0h.94v.939h-.94zm-.94-1.88h.939v.94h-.939z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_6090",
    x1: 9.73,
    y1: 0,
    x2: 256.877,
    y2: 204.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.14
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramesGroup);
export default __webpack_public_path__ + "static/media/frames-group.6c10dc48ece94b9cf3da30a21eb1c379.svg";
export { ForwardRef as ReactComponent };